var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as Sentry from '@sentry/browser';
import { isBotUserAgent } from '../src/utils/isBotTraffic';
var SCREEN_SIZE;
(function (SCREEN_SIZE) {
    SCREEN_SIZE["PHONE"] = "PHONE";
    SCREEN_SIZE["TABLET"] = "TABLET";
    SCREEN_SIZE["DESKTOP"] = "DESKTOP";
})(SCREEN_SIZE || (SCREEN_SIZE = {}));
var OS;
(function (OS) {
    OS["MAC_OS"] = "MAC_OS";
    OS["IOS"] = "IOS";
    OS["WINDOWS"] = "WINDOWS";
    OS["ANDROID"] = "ANDROID";
    OS["LINUX"] = "LINUX";
})(OS || (OS = {}));
var BROWSER;
(function (BROWSER) {
    BROWSER["OPERA"] = "OPERA";
    BROWSER["FIREFOX"] = "FIREFOX";
    BROWSER["SAFARI"] = "SAFARI";
    BROWSER["IE"] = "IE";
    BROWSER["EDGE"] = "EDGE";
    BROWSER["CHROME"] = "CHROME";
})(BROWSER || (BROWSER = {}));
var TestType;
(function (TestType) {
    TestType["AB"] = "AB";
    TestType["SPLIT"] = "SPLIT";
    TestType["PERSONALIZATION"] = "PERSONALIZATION";
})(TestType || (TestType = {}));
var ConversionType;
(function (ConversionType) {
    ConversionType["LEGACY_CLICK_SUBMIT"] = "LEGACY_CLICK_SUBMIT";
    ConversionType["CLICK"] = "CLICK";
    ConversionType["SUBMIT"] = "SUBMIT";
    ConversionType["PAGE_VIEW"] = "PAGE_VIEW";
    ConversionType["SCROLL_DEPTH"] = "SCROLL_DEPTH";
    ConversionType["TIME_ON_PAGE"] = "TIME_ON_PAGE";
    ConversionType["PROGRAMMATIC"] = "PROGRAMMATIC";
})(ConversionType || (ConversionType = {}));
var OPTIBASE_HIDDEN_CLASS_NAME = 'optibase-hidden';
var ScrollDepthUnit;
(function (ScrollDepthUnit) {
    ScrollDepthUnit["PIXELS"] = "PIXELS";
    ScrollDepthUnit["PERCENTAGE"] = "PERCENTAGE";
})(ScrollDepthUnit || (ScrollDepthUnit = {}));
var UrlMatchType;
(function (UrlMatchType) {
    UrlMatchType["EXACT"] = "EXACT";
    UrlMatchType["STARTS_WITH"] = "STARTS_WITH";
    UrlMatchType["CONTAINS"] = "CONTAINS";
    UrlMatchType["ENDS_WITH"] = "ENDS_WITH";
})(UrlMatchType || (UrlMatchType = {}));
Sentry.setTag('url', window.location.href);
var optibaseSentryClient = new Sentry.BrowserClient({
    dsn: 'https://3266931c85fced597df7d2c3891c380a@o4506872303845376.ingest.us.sentry.io/4506882884370432',
    transport: Sentry.makeFetchTransport,
    stackParser: Sentry.defaultStackParser,
    integrations: [],
    environment: process.env.NEXT_PUBLIC_VERCEL_ENV,
});
var OptibaseUserError = /** @class */ (function (_super) {
    __extends(OptibaseUserError, _super);
    function OptibaseUserError(message) {
        var _this = _super.call(this, message) || this; // 'Error' breaks prototype chain here
        Object.setPrototypeOf(_this, OptibaseUserError.prototype); // Restore prototype chain
        return _this;
    }
    return OptibaseUserError;
}(Error));
// Encapsulated in a function to create a localized scope
function Optibase() {
    var _this = this;
    if (window.optibaseScriptLoaded) {
        throw new OptibaseUserError('[Optibase] Detected duplicated Optibase Script.');
    }
    function log(scope) {
        var messages = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            messages[_i - 1] = arguments[_i];
        }
        if (debugMode) {
            console.log.apply(console, __spreadArray(["[Optibase ".concat(scope, "]:")], messages, false));
        }
    }
    // Validates the execution context of the current script element within the document.
    function validateExecution() {
        var _a, _b, _c;
        var currentScript = document.currentScript;
        if (!currentScript) {
            throw new Error('[Optibase] Javascript not running withing a script.');
        }
        var publicApiKey = (_b = (_a = currentScript.getAttribute('public-api-key')) !== null && _a !== void 0 ? _a : currentScript.getAttribute('data-public-api-key')) !== null && _b !== void 0 ? _b : new URL(currentScript.src).searchParams.get('public-api-key');
        if (!publicApiKey) {
            throw new OptibaseUserError('[Optibase] Error: Missing public-api-key attribute in script tag.');
        }
        var currentScriptSrc = currentScript.getAttribute('src');
        if (!currentScriptSrc) {
            throw new Error('[Optibase] Error: Missing src attribute in script tag.');
        }
        var currentScriptSrcUrl = null;
        try {
            currentScriptSrcUrl = new URL(currentScriptSrc);
        }
        catch (_d) { }
        if (!currentScriptSrcUrl) {
            throw new OptibaseUserError('[Optibase] Error: Invalid src attribute in script tag. It should be a valid URL. Current is url: ' +
                currentScriptSrc);
        }
        var baseApiUrl = "".concat(currentScriptSrcUrl.protocol, "//").concat(currentScriptSrcUrl.hostname).concat(currentScriptSrcUrl.port ? ':' + currentScriptSrcUrl.port : '');
        var canHideBody = true;
        if (currentScript.async) {
            console.error('[Optibase] Script is running as async. Remove async from the script.');
            canHideBody = false;
        }
        if (currentScript.defer) {
            console.error('[Optibase] Script is running as defer. Remove defer from the script.');
            canHideBody = false;
        }
        if (((_c = currentScript.parentNode) === null || _c === void 0 ? void 0 : _c.nodeName) !== 'HEAD') {
            console.error('[Optibase] Script is not in the head element. Move the script to the <head> element.');
            canHideBody = false;
        }
        log('validateExecution', "Found publicApiKey: ".concat(publicApiKey, ", baseApiUrl: ").concat(baseApiUrl, ", and canHideBody: ").concat(canHideBody, "."));
        return {
            publicApiKey: publicApiKey,
            baseApiUrl: baseApiUrl,
            canHideBody: canHideBody,
        };
    }
    function getConfig() {
        // Assume `window.location.search` contains the query string of the current URL
        var params = new URLSearchParams(window.location.search);
        // Debug Mode Config
        debugMode = Boolean(localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('optibaseDebugMode'));
        if (params.has('optibaseEnableDebugMode')) {
            log('getConfig', 'Params has optibaseEnableDebugMode; enabling debug mode.');
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem('optibaseDebugMode', 'true');
            debugMode = true;
        }
        if (params.has('optibaseDisableDebugMode')) {
            log('getConfig', 'Params has optibaseDisableDebugMode; disabling debug mode.');
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem('optibaseDebugMode');
            debugMode = false;
        }
        var previewVariant = null;
        var forcedVariants = [];
        // Preview Variants
        if (params.has('optibasePreviewVariant')) {
            var optibasePreviewVariant = params.get('optibasePreviewVariant');
            log('getConfig', 'Params has optibasePreviewVariant:', optibasePreviewVariant);
            var _a = optibasePreviewVariant.split(':'), userFriendlyTestId = _a[0], userFriendlyVariantId = _a[1];
            if (userFriendlyTestId && userFriendlyVariantId) {
                previewVariant = {
                    userFriendlyTestId: userFriendlyTestId,
                    userFriendlyVariantId: userFriendlyVariantId,
                };
            }
            else {
                console.error('[Optibase] Error: Invalid optibasePreviewVariant format. It should be "userFriendlyTestId:userFriendlyVariantId".');
            }
        }
        // Forced Variants
        if (params.has('optibaseVariants')) {
            var optibaseForcedVariantsSearchParam = params.get('optibaseVariants');
            log('getConfig', 'Params has optibaseVariants:', optibaseForcedVariantsSearchParam);
            var optibaseForcedVariants = optibaseForcedVariantsSearchParam
                .split(';')
                .map(function (optibaseForcedVariantSearchParam) {
                return optibaseForcedVariantSearchParam.split(':');
            });
            optibaseForcedVariants.forEach(function (_a) {
                var userFriendlyTestId = _a[0], userFriendlyVariantId = _a[1];
                if (userFriendlyTestId && userFriendlyVariantId) {
                    forcedVariants.push({
                        userFriendlyTestId: userFriendlyTestId,
                        userFriendlyVariantId: userFriendlyVariantId,
                    });
                }
                else {
                    console.error('[Optibase] Error: Invalid optibaseVariants format. It should be "userFriendlyTestId:userFriendlyVariantId".');
                }
            });
        }
        // Script Disabled Config
        var scriptDisabled = Boolean(localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('optibaseScriptDisabled'));
        if (params.has('optibaseDisableScript')) {
            log('getConfig', 'Params has optibaseDisableScript; disabling script.');
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem('optibaseScriptDisabled', 'true');
            scriptDisabled = true;
        }
        else if (params.has('optibaseEnableScript')) {
            log('getConfig', 'Params has optibaseEnableScript; enabling script.');
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem('optibaseScriptDisabled');
            scriptDisabled = false;
        }
        else if (previewVariant) {
            log('getConfig', 'Disabling script to show the preview variant.');
            scriptDisabled = true;
        }
        log('getConfig', "Found scriptDisabled: ".concat(scriptDisabled, ", debugMode: ").concat(debugMode, ", previewVariant:"), previewVariant, 'and forcedVariants:', forcedVariants);
        return { scriptDisabled: scriptDisabled, previewVariant: previewVariant, forcedVariants: forcedVariants };
    }
    function canUseHeatmaps() {
        return isProfessionalTierPlan();
    }
    function canUseRecordings() {
        return isProfessionalTierPlan();
    }
    function isProfessionalTierPlan(plan) {
        if (plan === void 0) { plan = window.optibaseSubscriptionPlan; }
        if (!plan) {
            return false;
        }
        return (plan.includes('PROFESSIONAL') ||
            plan.includes('ENTERPRISE') ||
            plan.includes('CUSTOM'));
    }
    function isBusinessTierPlan(plan) {
        if (plan === void 0) { plan = window.optibaseSubscriptionPlan; }
        if (!plan) {
            return false;
        }
        return plan.includes('BUSINESS') || isProfessionalTierPlan(plan);
    }
    function getCurrentBrowser() {
        var userAgent = window.navigator.userAgent.toLowerCase();
        var hasChromeToken = userAgent.includes('chrome') ||
            userAgent.includes('crios') ||
            userAgent.includes('crmo') ||
            userAgent.includes('chromium');
        var hasSafariToken = userAgent.includes('safari');
        var browser = userAgent.includes('edge') || userAgent.includes('edg/')
            ? BROWSER.EDGE
            : userAgent.includes('opr/') || userAgent.includes('opera')
                ? BROWSER.OPERA
                : hasChromeToken
                    ? BROWSER.CHROME
                    : userAgent.includes('trident') || userAgent.includes('msie')
                        ? BROWSER.IE
                        : userAgent.includes('firefox') || userAgent.includes('fxios')
                            ? BROWSER.FIREFOX
                            : hasSafariToken && !userAgent.includes('android')
                                ? BROWSER.SAFARI
                                : undefined;
        log('metadata', "Current Browser: ".concat(browser, "."));
        return browser;
    }
    function getCurrentOS() {
        var userAgent = window.navigator.userAgent;
        var platform = window.navigator.platform;
        var currentOS = undefined;
        if (/Macintosh|MacIntel|MacPPC|Mac68K|Darwin/.test(platform)) {
            currentOS = OS.MAC_OS;
        }
        else if (/iPhone|iPad|iPod/.test(platform)) {
            currentOS = OS.IOS;
        }
        else if (/Win32|Win64|Windows|WinCE/.test(platform)) {
            currentOS = OS.WINDOWS;
        }
        else if (/Android/.test(userAgent)) {
            currentOS = OS.ANDROID;
        }
        else if (/Linux/.test(platform)) {
            currentOS = OS.LINUX;
        }
        log('metadata', "Current OS: ".concat(currentOS, "."));
        return currentOS;
    }
    function getCurrentScreenSize() {
        var currentScreenSize = window.innerWidth <= 767
            ? SCREEN_SIZE.PHONE
            : window.innerWidth <= 990
                ? SCREEN_SIZE.TABLET
                : SCREEN_SIZE.DESKTOP;
        log('metadata', "Current Screen Size: ".concat(currentScreenSize, "."));
        return currentScreenSize;
    }
    function getCurrentTopReferrer() {
        var _a, _b;
        var currentTopReferrer;
        try {
            // Attempt to access the top frame's referrer
            currentTopReferrer = (_b = (_a = window === null || window === void 0 ? void 0 : window.frames) === null || _a === void 0 ? void 0 : _a.top) === null || _b === void 0 ? void 0 : _b.document.referrer;
        }
        catch (_c) {
            // If an error occurs (e.g., due to cross-origin Restrictions), handle it gracefully
            currentTopReferrer = undefined;
        }
        log('metadata', "Current Top Refferer: ".concat(currentTopReferrer, "."));
        return currentTopReferrer;
    }
    function getCurrentOriginUrl() {
        var currentOriginUrl = window.location.origin + window.location.pathname;
        log('metadata', "Current Origin Url: ".concat(currentOriginUrl, "."));
        return currentOriginUrl;
    }
    function getUtmParams() {
        var params = new URLSearchParams(window.location.search);
        var utmSource = params.get('utm_source') || undefined;
        var utmCampaign = params.get('utm_campaign') || undefined;
        var utmContent = params.get('utm_content') || undefined;
        var utmMedium = params.get('utm_medium') || undefined;
        log('metadata', "UTM Params: source=".concat(utmSource, ", campaign=").concat(utmCampaign, ", content=").concat(utmContent, ", medium=").concat(utmMedium));
        return { utmSource: utmSource, utmCampaign: utmCampaign, utmContent: utmContent, utmMedium: utmMedium };
    }
    function hasGclidParameter() {
        return new URLSearchParams(window.location.search)
            .getAll('gclid')
            .some(function (value) { return value.trim().length > 0; });
    }
    function getClientTimeData() {
        var now = new Date();
        var hour = now.getHours();
        var timeOfDay = hour < 12 ? 'AM' : 'PM';
        var days = [
            'SUNDAY',
            'MONDAY',
            'TUESDAY',
            'WEDNESDAY',
            'THURSDAY',
            'FRIDAY',
            'SATURDAY',
        ];
        var dayOfWeek = days[now.getDay()];
        log('metadata', "Client time: timeOfDay=".concat(timeOfDay, ", dayOfWeek=").concat(dayOfWeek));
        return { timeOfDay: timeOfDay, dayOfWeek: dayOfWeek };
    }
    function getBrowserLanguage() {
        var language = navigator === null || navigator === void 0 ? void 0 : navigator.language;
        if (!language)
            return undefined;
        log('metadata', "Browser Language: ".concat(language));
        return language;
    }
    function validateAndCleanUrl(url) {
        try {
            var urlObject = new URL(url.startsWith('http') ? url : "https://".concat(url));
            return urlObject.origin + urlObject.pathname;
        }
        catch (_) {
            return null;
        }
    }
    function normalizeUrlForTracking(url) {
        try {
            var urlObject = new URL(url.startsWith('http') ? url : "https://".concat(url));
            urlObject.protocol = 'https:';
            if (urlObject.hostname.startsWith('www.')) {
                urlObject.hostname = urlObject.hostname.slice(4);
            }
            return urlObject.origin + urlObject.pathname;
        }
        catch (_) {
            return null;
        }
    }
    function validateAndExtractPathFromUrl(url) {
        try {
            var urlObject = new URL(url.startsWith('http') ? url : "https://".concat(url));
            return urlObject.pathname;
        }
        catch (_) {
            return null;
        }
    }
    var hideBodyStyle = document.createElement('style');
    function hideBody() {
        log('hideBody', 'Hiding body.');
        // Set the CSS text for making the body invisible with !important to ensure it takes precedence
        hideBodyStyle.innerHTML = 'body { visibility: hidden !important; }';
        // Append the <style> element to the <head> of the document
        document.head.appendChild(hideBodyStyle);
    }
    function showBody() {
        var _a;
        log('showBody', 'Showing body.');
        (_a = hideBodyStyle.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(hideBodyStyle);
    }
    function injectVariantCustomCode(testId, variantId, customCss, customJs, fromCached) {
        // Remove any existing CSS for this test (different variant may have been cached)
        document
            .querySelectorAll("style[id^=\"optibase-css-".concat(testId, "-\"]"))
            .forEach(function (el) { return el.remove(); });
        if (customCss) {
            var cssId = "optibase-css-".concat(testId, "-").concat(variantId);
            var style = document.createElement('style');
            style.id = cssId;
            style.textContent = customCss;
            document.head.appendChild(style);
            log('injectVariantCustomCode', "Injected CSS for ".concat(testId, "/").concat(variantId));
        }
        if (customJs && !fromCached) {
            var script = document.createElement('script');
            script.textContent = customJs;
            document.head.appendChild(script);
            log('injectVariantCustomCode', "Injected JS for ".concat(testId, "/").concat(variantId));
        }
    }
    function showOptibaseVariantElement(element) {
        element.classList.remove(OPTIBASE_HIDDEN_CLASS_NAME);
        if (element.style.display === 'none') {
            element.style.display = '';
        }
    }
    function getInitialize(testsOnPage, conversionsOnPage) {
        return __awaiter(this, void 0, void 0, function () {
            var activeResponse, activeResponseJson, hasExistingTestedUserId, storedConsent, shouldRequestTracking, utmParams, clientTimeData, initializeBody, response, responseJson_1, responseText, responseJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        log('getInitialize', "Fetching active for publicApiKey: ".concat(publicApiKey, "."));
                        return [4 /*yield*/, fetch(baseApiUrl +
                                "/api/script/active?publicApiKey=".concat(publicApiKey, "&hostname=").concat(window.location.hostname)).catch(function () { })];
                    case 1:
                        activeResponse = _a.sent();
                        if (!activeResponse) {
                            // Don't surface the error to Sentry because it's usually a network error.
                            throw new OptibaseUserError("[Optibase] Error occurred while fetching active.");
                        }
                        if (!activeResponse.ok) {
                            throw new OptibaseUserError("[Optibase] Error occurred while fetching active.");
                        }
                        return [4 /*yield*/, activeResponse.json()];
                    case 2:
                        activeResponseJson = _a.sent();
                        log('getInitialize', "Active response:", activeResponseJson);
                        if (activeResponseJson === null || activeResponseJson === void 0 ? void 0 : activeResponseJson.bot) {
                            log('getInitialize', 'Bot sentinel returned from active endpoint');
                            return [2 /*return*/, {
                                    bot: true,
                                    noTestsOrConversionsOnPage: true,
                                    randomSeed: Math.floor(Math.random() * 1000000000),
                                }];
                        }
                        if (!activeResponseJson.active) {
                            return [2 /*return*/, {
                                    userNotLoggedIn7Days: true,
                                    randomSeed: Math.floor(Math.random() * 1000000000),
                                }];
                        }
                        window.optibaseSubscriptionPlan = activeResponseJson.subscriptionPlan;
                        // Store consent mode and banner config from active response
                        consentMode = activeResponseJson.consentMode || 'default';
                        consentBannerConfig = activeResponseJson.consentBannerConfig || null;
                        log('getInitialize', "Consent mode: ".concat(consentMode));
                        hasExistingTestedUserId = Boolean(testedUserId);
                        storedConsent = getStoredConsent();
                        userDeclinedConsent = storedConsent === false;
                        // Backwards compatibility: if user has existing testedUserId and hasn't explicitly declined, enable tracking
                        if (hasExistingTestedUserId && !userDeclinedConsent) {
                            trackingEnabled = true;
                            log('getInitialize', 'Returning user with testedUserId, tracking enabled');
                        }
                        else if (storedConsent === true) {
                            trackingEnabled = true;
                            log('getInitialize', 'User previously consented, tracking enabled');
                        }
                        else if (consentMode === 'default') {
                            trackingEnabled = true;
                            log('getInitialize', 'Default consent mode, tracking enabled');
                        }
                        if (userDeclinedConsent) {
                            log('getInitialize', 'User previously declined consent');
                        }
                        shouldRequestTracking = trackingEnabled;
                        utmParams = getUtmParams();
                        clientTimeData = getClientTimeData();
                        initializeBody = {
                            publicApiKey: publicApiKey,
                            testedUserId: testedUserId,
                            entryUrl: currentOriginUrl,
                            screenSize: currentScreenSize,
                            browser: currentBrowser,
                            OS: currentOS,
                            topReferrer: currentTopReferrer,
                            testsOnPage: testsOnPage,
                            conversionsOnPage: conversionsOnPage,
                            utmSource: utmParams.utmSource,
                            utmCampaign: utmParams.utmCampaign,
                            utmContent: utmParams.utmContent,
                            utmMedium: utmParams.utmMedium,
                            hasGclid: hasGclidParameter(),
                            timeOfDay: clientTimeData.timeOfDay,
                            dayOfWeek: clientTimeData.dayOfWeek,
                            browserLanguage: getBrowserLanguage(),
                            tracking: shouldRequestTracking,
                        };
                        log('getInitialize', "Calling with body:", initializeBody);
                        return [4 /*yield*/, fetch(baseApiUrl + "/api/script/initialize", {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify(initializeBody),
                                credentials: 'include',
                            }).catch(function () { })];
                    case 3:
                        response = _a.sent();
                        if (!response) {
                            // Don't surface the error to Sentry because
                            // it's usually a network error
                            throw new OptibaseUserError("[Optibase] Error occurred while fetching initialize.");
                        }
                        if (!!response.ok) return [3 /*break*/, 6];
                        return [4 /*yield*/, response.json().catch(function () { })];
                    case 4:
                        responseJson_1 = _a.sent();
                        return [4 /*yield*/, response.text().catch(function () { })];
                    case 5:
                        responseText = _a.sent();
                        if (response.status === 400 && !responseJson_1.clientError) {
                            // This means it was a user error, like running on
                            // a non valid domain
                            throw new OptibaseUserError('[Optibase] Response not ok when calling getInitialize: ' +
                                (responseJson_1 === null || responseJson_1 === void 0 ? void 0 : responseJson_1.message) ||
                                responseText ||
                                'Unknown error');
                        }
                        else if (response.status === 500) {
                            // This means it was an error on the server, don't surface to Sentry
                            throw new OptibaseUserError('[Optibase] Response not ok when calling getInitialize: ' +
                                (responseJson_1 === null || responseJson_1 === void 0 ? void 0 : responseJson_1.message) ||
                                responseText ||
                                'Internal Server Error');
                        }
                        else {
                            throw new Error('[Optibase] Response not ok when calling getInitialize: ' +
                                (responseJson_1 === null || responseJson_1 === void 0 ? void 0 : responseJson_1.message) ||
                                responseText ||
                                'Unknown error');
                        }
                        _a.label = 6;
                    case 6: return [4 /*yield*/, response.json()];
                    case 7:
                        responseJson = _a.sent();
                        log('getInitialize', "Response:", responseJson);
                        if (responseJson === null || responseJson === void 0 ? void 0 : responseJson.bot) {
                            log('getInitialize', 'Bot sentinel returned from initialize endpoint');
                            return [2 /*return*/, {
                                    bot: true,
                                    noTestsOrConversionsOnPage: true,
                                    randomSeed: typeof responseJson.randomSeed === 'number'
                                        ? responseJson.randomSeed
                                        : Math.floor(Math.random() * 1000000000),
                                }];
                        }
                        return [2 /*return*/, responseJson];
                }
            });
        });
    }
    var randomNumberGeneratorSeed = 0;
    function generateSeededRandomNumber() {
        // Constants for the LCG algorithm
        var a = 1664525;
        var c = 1013904223;
        var m = Math.pow(2, 32);
        // Update the seed and return a pseudo-random value
        randomNumberGeneratorSeed = (a * randomNumberGeneratorSeed + c) % m;
        return randomNumberGeneratorSeed / m;
    }
    function handleCachedInitializeResponse(testsOnPage, conversionsOnPage) {
        var _a, _b, _c;
        // Get the cached response specific to the current page configuration
        var cacheKey = "optibaseCachedInitializeResponse-tests".concat(testsOnPage, "-conversions").concat(conversionsOnPage);
        var specificCachedResponse = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(cacheKey);
        if (specificCachedResponse) {
            var cachedInitializeResponse = JSON.parse(specificCachedResponse);
            if (cachedInitializeResponse.monthlyTestedUsersLimitReached) {
                window.monthlyTestedUsersLimitReached = true;
            }
            var manualHeatmapMatches = getStandaloneHeatmapMatches(cachedInitializeResponse);
            var manualRecordingMatches = getStandaloneRecordingMatches(cachedInitializeResponse);
            log('handleCachedInitializeResponse', "Detected cached getInitialize response for tests=".concat(testsOnPage, ", conversions=").concat(conversionsOnPage, ":"), cachedInitializeResponse);
            if (!cachedInitializeResponse.randomSeed) {
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem(cacheKey);
                throw new Error('[Optibase] Random seed not returned.');
            }
            randomNumberGeneratorSeed = cachedInitializeResponse.randomSeed;
            amplitudeEnabled = (_a = cachedInitializeResponse.amplitudeEnabled) !== null && _a !== void 0 ? _a : false;
            var willRedirect = handleSplitTests(((_b = cachedInitializeResponse.tests) === null || _b === void 0 ? void 0 : _b.filter(function (test) { return test.eligible && test.test.type === TestType.SPLIT; })) || [], true, previewVariant, forcedVariants);
            if (!willRedirect) {
                handleABTests(((_c = cachedInitializeResponse.tests) === null || _c === void 0 ? void 0 : _c.filter(function (test) { return test.test.type === TestType.AB; })) || [], true, previewVariant, forcedVariants);
                // Handle personalizations (audience rules evaluated server-side)
                handlePersonalizations(cachedInitializeResponse.personalizations || [], true, previewVariant, forcedVariants);
                showBody();
                // Load heatmap/recording scripts based on standalone matches
                if (!scriptDisabled) {
                    if (manualHeatmapMatches.length > 0 &&
                        canUseHeatmaps() &&
                        !window.monthlyTestedUsersLimitReached) {
                        loadHeatmapScript(baseApiUrl, publicApiKey);
                    }
                    if (manualRecordingMatches.length > 0 &&
                        canUseRecordings() &&
                        !window.monthlyTestedUsersLimitReached) {
                        loadRecordingScript(baseApiUrl, publicApiKey);
                    }
                }
            }
        }
        else {
            log('handleCachedInitializeResponse', "No cached getInitialize response for tests=".concat(testsOnPage, ", conversions=").concat(conversionsOnPage));
        }
    }
    function getStandaloneHeatmapMatches(response) {
        var manualHeatmaps = response.standaloneHeatmaps || [];
        if (!manualHeatmaps.length) {
            window.optibaseManualHeatmapUrls = [];
            return [];
        }
        var normalizedCurrentUrl = normalizeUrlForTracking(currentOriginUrl);
        var matches = manualHeatmaps.filter(function (heatmap) {
            try {
                var normalizedUrl = normalizeUrlForTracking(heatmap.url);
                return normalizedUrl === normalizedCurrentUrl;
            }
            catch (_a) {
                return false;
            }
        });
        window.optibaseManualHeatmapUrls = matches.map(function (heatmap) { return heatmap.url; });
        return matches;
    }
    function getStandaloneRecordingMatches(response) {
        var manualRecordings = response.standaloneRecordings || [];
        if (!manualRecordings.length) {
            window.optibaseManualRecordingUrls = [];
            return [];
        }
        var normalizedCurrentUrl = normalizeUrlForTracking(currentOriginUrl);
        var matches = manualRecordings.filter(function (recording) {
            try {
                var normalizedUrl = normalizeUrlForTracking(recording.url);
                return normalizedUrl === normalizedCurrentUrl;
            }
            catch (_a) {
                return false;
            }
        });
        window.optibaseManualRecordingUrls = matches.map(function (recording) { return recording.url; });
        return matches;
    }
    function handleInitializeResponse(initializeResponse, testsOnPage, conversionsOnPage) {
        return __awaiter(this, void 0, void 0, function () {
            var cacheKey, manualHeatmapMatches, manualRecordingMatches, willRedirect, timeToSetup;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        if (initializeResponse.bot) {
                            log('handleInitializeResponse', 'Bot sentinel received; skipping setup');
                            window.optibaseInitialized = true;
                            showBody();
                            return [2 /*return*/];
                        }
                        if (initializeResponse.monthlyTestedUsersLimitReached) {
                            window.monthlyTestedUsersLimitReached = true;
                            console.error('[Optibase] The Monthly Tested Users limit has been reached.');
                        }
                        if (initializeResponse.noTestsOrConversionsOnPage) {
                            window.noTestsOrConversionsOnPage = true;
                            log('handleInitializeResponse', "No tests or conversions found on the page.");
                        }
                        if (initializeResponse.userNotLoggedIn7Days) {
                            window.userNotLoggedIn7Days = true;
                            console.error('handleInitializeResponse', 'The user has not logged in in the last 7 days, please log in again to start running tests. It might take up to 2h after logging in for the script to be active again.');
                        }
                        if (!initializeResponse.randomSeed) {
                            throw new Error('[Optibase] Random seed not returned.');
                        }
                        cacheKey = "optibaseCachedInitializeResponse-tests".concat(testsOnPage, "-conversions").concat(conversionsOnPage);
                        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(cacheKey, JSON.stringify(initializeResponse));
                        randomNumberGeneratorSeed = initializeResponse.randomSeed;
                        amplitudeEnabled = (_a = initializeResponse.amplitudeEnabled) !== null && _a !== void 0 ? _a : false;
                        if (initializeResponse.testedUserId) {
                            testedUserId = initializeResponse.testedUserId;
                            window.optibaseTestedUserId = testedUserId;
                            (_b = window.localStorage) === null || _b === void 0 ? void 0 : _b.setItem('optibaseTestedUserId', initializeResponse.testedUserId);
                        }
                        if (initializeResponse.testedUserExternalId) {
                            testedUserExternalId = initializeResponse.testedUserExternalId;
                            window.optibaseTestedUserExternalId =
                                initializeResponse.testedUserExternalId;
                            (_c = window.localStorage) === null || _c === void 0 ? void 0 : _c.setItem('optibaseTestedUserExternalId', initializeResponse.testedUserExternalId);
                        }
                        manualHeatmapMatches = getStandaloneHeatmapMatches(initializeResponse);
                        manualRecordingMatches = getStandaloneRecordingMatches(initializeResponse);
                        willRedirect = handleSplitTests(((_d = initializeResponse.tests) === null || _d === void 0 ? void 0 : _d.filter(function (test) { return test.eligible && test.test.type === TestType.SPLIT; })) || [], false, previewVariant, forcedVariants);
                        if (willRedirect) {
                            return [2 /*return*/];
                        }
                        handleABTests(((_e = initializeResponse.tests) === null || _e === void 0 ? void 0 : _e.filter(function (test) { return test.test.type === TestType.AB; })) || [], false, previewVariant, forcedVariants);
                        // Handle personalizations (audience rules evaluated server-side)
                        handlePersonalizations(initializeResponse.personalizations || [], false, previewVariant, forcedVariants);
                        window.optibaseInitialized = true;
                        showBody();
                        timeToSetup = new Date().getTime() - startDate.getTime();
                        // Store pending variants for consent-based tracking
                        pendingViewVariants = __spreadArray([], shownVariants, true);
                        // Cache conversions for later use if tracking is enabled after consent
                        cachedConversions = initializeResponse.conversions || [];
                        // Calculate and cache heatmap/recording flags for deferred loading after consent
                        shouldLoadHeatmapScriptOnConsent = Boolean(manualHeatmapMatches.length > 0 &&
                            canUseHeatmaps() &&
                            !window.monthlyTestedUsersLimitReached);
                        shouldLoadRecordingScriptOnConsent = Boolean(manualRecordingMatches.length > 0 &&
                            canUseRecordings() &&
                            !window.monthlyTestedUsersLimitReached);
                        if (!!scriptDisabled) return [3 /*break*/, 3];
                        if (!trackingEnabled) return [3 /*break*/, 2];
                        // Tracking is enabled - proceed with normal flow
                        handleClickConversions(((_f = initializeResponse.conversions) === null || _f === void 0 ? void 0 : _f.filter(function (conversion) {
                            return conversion.type === ConversionType.CLICK ||
                                conversion.type === ConversionType.LEGACY_CLICK_SUBMIT;
                        })) || []);
                        handleSubmitConversions(((_g = initializeResponse.conversions) === null || _g === void 0 ? void 0 : _g.filter(function (conversion) {
                            return conversion.type === ConversionType.SUBMIT ||
                                conversion.type === ConversionType.LEGACY_CLICK_SUBMIT;
                        })) || []);
                        handleScrollDepthConversions(((_h = initializeResponse.conversions) === null || _h === void 0 ? void 0 : _h.filter(function (conversion) { return conversion.type === ConversionType.SCROLL_DEPTH; })) || []);
                        handleTimeOnPageConversions(((_j = initializeResponse.conversions) === null || _j === void 0 ? void 0 : _j.filter(function (conversion) { return conversion.type === ConversionType.TIME_ON_PAGE; })) || []);
                        // Send a view event for all selected variants
                        return [4 /*yield*/, sendView(timeToSetup)];
                    case 1:
                        // Send a view event for all selected variants
                        _l.sent();
                        handlePageViewConversion(((_k = initializeResponse.conversions) === null || _k === void 0 ? void 0 : _k.filter(function (conversion) { return conversion.type === ConversionType.PAGE_VIEW; })) || []);
                        // Load heatmap and recording scripts
                        if (shouldLoadHeatmapScriptOnConsent &&
                            !window.monthlyTestedUsersLimitReached) {
                            loadHeatmapScript(baseApiUrl, publicApiKey);
                        }
                        if (shouldLoadRecordingScriptOnConsent &&
                            !window.monthlyTestedUsersLimitReached) {
                            loadRecordingScript(baseApiUrl, publicApiKey);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        if (consentMode === 'optibase' && !userDeclinedConsent) {
                            // Show consent banner for 'optibase' mode (only if user hasn't declined before)
                            log('handleInitializeResponse', 'Showing consent banner (optibase mode)');
                            showConsentBanner();
                        }
                        else if (consentMode === 'optibase' && userDeclinedConsent) {
                            // User previously declined - don't show banner again
                            log('handleInitializeResponse', 'User previously declined consent, not showing banner');
                        }
                        else if (consentMode === 'external') {
                            // External mode - wait for window.optibaseEnableTracking() call
                            log('handleInitializeResponse', 'External consent mode - waiting for optibaseEnableTracking()');
                        }
                        _l.label = 3;
                    case 3:
                        log('handleInitializeResponse', "Finished setting up Optibase. Time to setup: ".concat(timeToSetup, "ms."));
                        return [2 /*return*/];
                }
            });
        });
    }
    function loadHeatmapScript(baseApiUrl, publicApiKey) {
        log('loadHeatmapScript', 'Loading heatmap tracking script');
        // Check if script is already loaded
        if (document.querySelector('script[data-optibase-heatmap]')) {
            log('loadHeatmapScript', 'Heatmap script already loaded');
            return;
        }
        var script = document.createElement('script');
        script.setAttribute('data-optibase-heatmap', 'true');
        script.setAttribute('public-api-key', publicApiKey);
        script.src = "".concat(baseApiUrl, "/script-heatmap.js");
        script.async = true;
        script.onerror = function () {
            console.error('[Optibase] Failed to load heatmap script');
        };
        document.head.appendChild(script);
        log('loadHeatmapScript', 'Heatmap script loaded');
    }
    function loadRecordingScript(baseApiUrl, publicApiKey) {
        log('loadRecordingScript', 'Loading recording tracking script');
        // Check if script is already loaded
        if (document.querySelector('script[data-optibase-recording]')) {
            log('loadRecordingScript', 'Recording script already loaded');
            return;
        }
        var script = document.createElement('script');
        script.setAttribute('data-optibase-recording', 'true');
        script.setAttribute('public-api-key', publicApiKey);
        script.src = "".concat(baseApiUrl, "/script-recording.js");
        script.async = true;
        script.onerror = function () {
            console.error('[Optibase] Failed to load recording script');
        };
        document.head.appendChild(script);
        log('loadRecordingScript', 'Recording script loaded');
    }
    function doesUrlMatchCurrentOrigin(url, sameOrigin, urlMatchType) {
        if (!url)
            return false;
        var pageUrl = sameOrigin ? cleanCurrentOriginPath : cleanCurrentOriginUrl;
        switch (urlMatchType) {
            case UrlMatchType.EXACT:
                return pageUrl === url;
            case UrlMatchType.STARTS_WITH:
                return pageUrl.startsWith(url);
            case UrlMatchType.CONTAINS:
                return pageUrl.includes(url);
            case UrlMatchType.ENDS_WITH:
                return pageUrl.endsWith(url);
        }
    }
    function getUrl(url) {
        return new URL(decodeURIComponent(url), window.location.href);
    }
    function normalizeSplitTestPath(pathname) {
        // Match canonical redirects that add or remove a trailing slash.
        return pathname.replace(/\/+$/, '') || '/';
    }
    function doesSplitTestEntryUrlMatchCurrentPage(url, sameOrigin) {
        if (!url)
            return false;
        // Preserve exact entry matching, including the absolute URL requirement
        // when sameOrigin is false. Only tolerate trailing slash differences.
        var pageUrl = sameOrigin ? cleanCurrentOriginPath : cleanCurrentOriginUrl;
        return pageUrl.replace(/\/+$/, '') === url.replace(/\/+$/, '');
    }
    function doesVariantUrlMatchCurrentPage(variant) {
        if (!variant.url)
            return false;
        try {
            var variantUrl = getUrl(variant.url);
            var currentUrl_1 = new URL(window.location.href);
            var currentPath = normalizeSplitTestPath(currentUrl_1.pathname);
            var variantPath = normalizeSplitTestPath(variantUrl.pathname);
            var currentBaseUrl = variant.sameOrigin
                ? currentPath
                : currentUrl_1.origin + currentPath;
            var variantBaseUrl = variant.sameOrigin
                ? variantPath
                : variantUrl.origin + variantPath;
            if (currentBaseUrl !== variantBaseUrl) {
                return false;
            }
            return Array.from(variantUrl.searchParams.entries()).every(function (_a) {
                var key = _a[0], value = _a[1];
                return currentUrl_1.searchParams.getAll(key).includes(value);
            });
        }
        catch (_) {
            return false;
        }
    }
    function getVariantUrlSearchParamCount(variant) {
        if (!variant.url)
            return 0;
        try {
            return Array.from(getUrl(variant.url).searchParams).length;
        }
        catch (_) {
            return 0;
        }
    }
    function getCurrentPageSplitVariant(variants) {
        return variants
            .filter(function (variant) { return doesVariantUrlMatchCurrentPage(variant); })
            .sort(function (a, b) {
            return getVariantUrlSearchParamCount(b) - getVariantUrlSearchParamCount(a);
        })[0];
    }
    function getRedirectUrlWithCurrentParams(url) {
        var redirectUrl = getUrl(url);
        var currentParams = new URLSearchParams(window.location.search);
        currentParams.forEach(function (value, key) {
            if (!redirectUrl.searchParams.getAll(key).includes(value)) {
                redirectUrl.searchParams.append(key, value);
            }
        });
        return redirectUrl.toString();
    }
    function selectRandomWeightedVariant(variants, randomNumber) {
        // Calculate the total weight
        var totalWeight = variants.reduce(function (acc, variant) { return acc + (variant.trafficSplitWeight || 0); }, 0);
        // Scale the random number with the total weight
        var scaledRandom = randomNumber * totalWeight;
        // Iterate through the variants to find the selected one based on the scaled random number
        for (var _i = 0, variants_1 = variants; _i < variants_1.length; _i++) {
            var variant = variants_1[_i];
            // Subtract the variant's weight from the scaled random number
            scaledRandom -= variant.trafficSplitWeight || 0;
            // If the scaled random number is less than or equal to zero, we've found our variant
            if (scaledRandom <= 0) {
                return variant;
            }
        }
        // In case all variants are passed but no selection is made (should not happen in theory),
        // return the last variant as a fallback
        return variants[variants.length - 1];
    }
    // Manages split tests by determining if the current page matches a split test variant.
    // If a match is found and it's not the main variant, the user is redirected to the variant page.
    // This function also handles storing and retrieving previously shown variants from localStorage?.
    function handleSplitTests(splitTests, fromCached, previewVariant, forcedVariants) {
        var logScope = fromCached ? 'handleSplitTests cached' : 'handleSplitTests';
        log(logScope, "Handling Split Tests splitTests:", splitTests, 'fromCached', fromCached);
        var splitTestWeightedRandomVariant = null;
        var previewOrForcedOrWinnerVariant = false;
        var dontPushVariant = false;
        var splitTestToRun = null;
        var _loop_1 = function (splitTest) {
            log(logScope, "Checking split test:", splitTest);
            var entryVariant = splitTest.test.variants.find(function (variant) { return variant.main; });
            var entryUrl = entryVariant.url;
            var sameOrigin = entryVariant.sameOrigin;
            var randomNumber = generateSeededRandomNumber();
            log(logScope, "Checking if URL matches the current origin. entryUrl: ".concat(entryUrl, ", sameOrigin: ").concat(sameOrigin, "."));
            if (doesSplitTestEntryUrlMatchCurrentPage(entryUrl, sameOrigin)) {
                log(logScope, "URL matches the current origin. Checking for a variant to run.");
                splitTestToRun = splitTest;
                if ((previewVariant === null || previewVariant === void 0 ? void 0 : previewVariant.userFriendlyTestId) === splitTest.test.userFriendlyId) {
                    var previewVariantIndex = splitTest.test.variants.findIndex(function (variant) {
                        return variant.userFriendlyId === (previewVariant === null || previewVariant === void 0 ? void 0 : previewVariant.userFriendlyVariantId);
                    });
                    if (previewVariantIndex !== -1) {
                        splitTestWeightedRandomVariant =
                            splitTest.test.variants[previewVariantIndex];
                        previewOrForcedOrWinnerVariant = true;
                        dontPushVariant = true;
                        log(logScope, "Selected preview variant:", splitTestWeightedRandomVariant);
                    }
                }
                else if (forcedVariants.length) {
                    var forcedVariantIndex = splitTest.test.variants.findIndex(function (variant) {
                        return forcedVariants.find(function (forcedVariant) {
                            return forcedVariant.userFriendlyVariantId ===
                                variant.userFriendlyId &&
                                forcedVariant.userFriendlyTestId ===
                                    (splitTestToRun === null || splitTestToRun === void 0 ? void 0 : splitTestToRun.test.userFriendlyId);
                        });
                    });
                    if (forcedVariantIndex !== -1) {
                        splitTestWeightedRandomVariant =
                            splitTest.test.variants[forcedVariantIndex];
                        previewOrForcedOrWinnerVariant = true;
                        log(logScope, "Selected forced variant:", splitTestWeightedRandomVariant);
                    }
                }
                else if (scriptDisabled) {
                    dontPushVariant = true;
                    log(logScope, "Skipping handling Split Tests because script is disabled.");
                    return { value: false };
                }
                else if (splitTest.test.winnerVariantFriendlyId) {
                    var winnerVariant = splitTest.test.variants.find(function (variant) {
                        return variant.userFriendlyId === splitTest.test.winnerVariantFriendlyId;
                    });
                    if (!winnerVariant) {
                        console.error("[Optibase] Error: Winner Variant with ID \"".concat(splitTest.test.winnerVariantFriendlyId, "\" does not exist."));
                        return { value: false };
                    }
                    dontPushVariant = true;
                    log(logScope, "Selected winner variant:", winnerVariant);
                    splitTestWeightedRandomVariant = winnerVariant;
                    previewOrForcedOrWinnerVariant = true;
                }
                else {
                    splitTestWeightedRandomVariant = selectRandomWeightedVariant(splitTest.test.variants, randomNumber);
                    log(logScope, "Selected random variant:", splitTestWeightedRandomVariant);
                }
            }
            if (!fromCached &&
                !previewVariant &&
                !dontPushVariant &&
                !scriptDisabled) {
                var currentPageSplitVariant = getCurrentPageSplitVariant(splitTest.test.variants);
                if (currentPageSplitVariant) {
                    log(logScope, "Found a split test variant for the current page.");
                    shownVariants.push({
                        userFriendlyTestId: splitTest.test.userFriendlyId,
                        userFriendlyVariantId: currentPageSplitVariant.userFriendlyId,
                    });
                    // Only inject here if this isn't the splitTestToRun (which handles injection separately)
                    if (splitTest !== splitTestToRun) {
                        injectVariantCustomCode(splitTest.test.userFriendlyId, currentPageSplitVariant.userFriendlyId, currentPageSplitVariant.customCss, currentPageSplitVariant.customJs, fromCached);
                    }
                }
            }
        };
        for (var _i = 0, splitTests_1 = splitTests; _i < splitTests_1.length; _i++) {
            var splitTest = splitTests_1[_i];
            var state_1 = _loop_1(splitTest);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        // Check if there's a split test to run for the current page
        if (splitTestToRun && splitTestWeightedRandomVariant) {
            log(logScope, "Found split test to run:", splitTestToRun);
            var shownBeforeVariant = splitTestToRun.test.variants.find(function (variant) { return variant.shownBefore; });
            var selectedVariant = previewOrForcedOrWinnerVariant
                ? splitTestWeightedRandomVariant
                : shownBeforeVariant || splitTestWeightedRandomVariant;
            log(logScope, "Selected variant:", selectedVariant);
            // Check if the selected variant is the current page
            // If the selected variant is the current page, log and keep the user on the same page
            if (selectedVariant.main ||
                doesVariantUrlMatchCurrentPage(selectedVariant)) {
                log(logScope, "Not redirecting because selected variant is the current page.");
                if (splitTestToRun && !scriptDisabled) {
                    injectVariantCustomCode(splitTestToRun.test.userFriendlyId, selectedVariant.userFriendlyId, selectedVariant.customCss, selectedVariant.customJs, fromCached);
                }
                return false;
            }
            else if (!previewVariant || previewOrForcedOrWinnerVariant) {
                if (!fromCached) {
                    log(logScope, "Redirecting to ".concat(selectedVariant.url, "."));
                    // If a different variant is selected, redirect the user to that variant's URL
                    var redirectUrl = getRedirectUrlWithCurrentParams(selectedVariant.url);
                    window.location.href = redirectUrl;
                }
                return true;
            }
            else {
                return true;
            }
        }
        else {
            log(logScope, "Found no split test to run.");
        }
        return false;
    }
    // Executes A/B tests by selectively showing or hiding elements based on the A/B test variants.
    // Elements associated with non-selected variants are either hidden or removed from the DOM.
    function handleABTests(abTests, fromCached, previewVariant, forcedVariants) {
        var logScope = fromCached ? 'handleABTests cached' : 'handleABTests';
        log(logScope, "Handling A/B Tests abTests:", abTests, ' fromCached:', fromCached);
        // Query the document for elements involved in A/B tests
        // Only query for elements with data-optibase-test-id to avoid matching personalization elements
        // Personalizations use data-optibase-personalization-id instead
        var elements = document.querySelectorAll('[data-optibase-test-id]');
        if (elements.length === 0) {
            log(logScope, "No elements with A/B testing attributes found.");
            return;
        }
        // Initialize groups to organize elements by their test ID
        var testVariantGroups = new Map();
        elements.forEach(function (el) {
            var userFriendlyTestId = el.getAttribute('data-optibase-test-id');
            var userFriendlyVariantId = el.getAttribute('data-optibase-variant-id');
            // Validate the presence of necessary attributes
            if (!userFriendlyTestId) {
                // This shouldn't happen since we queried for it, but skip just in case
                return;
            }
            if (!userFriendlyVariantId) {
                console.error("[Optibase] Error: Element on the site missing 'data-optibase-variant-id' attribute. Test ID: ".concat(userFriendlyTestId));
                return;
            }
            // Skip if this element is a personalization (they use data-optibase-personalization-id)
            // This is a safety check in case the query somehow matches personalization elements
            if (el.getAttribute('data-optibase-personalization-id')) {
                return;
            }
            var abTest = abTests === null || abTests === void 0 ? void 0 : abTests.find(function (abTest) { return abTest.test.userFriendlyId === userFriendlyTestId; });
            if (!abTest) {
                if (!fromCached) {
                    console.error("[Optibase] Error: Element on the site is not part of any test. Invalid Test ID: ".concat(userFriendlyTestId));
                }
                return;
            }
            if (!abTest.test.variants.find(function (variant) { return variant.userFriendlyId === userFriendlyVariantId; })) {
                if (fromCached) {
                    console.error("[Optibase] Error: Element on the site is not part of any test. Invalid Variant ID: ".concat(userFriendlyVariantId));
                }
                return;
            }
            // Group elements by their test ID
            if (!testVariantGroups.has(userFriendlyTestId)) {
                testVariantGroups.set(userFriendlyTestId, []);
            }
            testVariantGroups.get(userFriendlyTestId).push(el);
        });
        log(logScope, "Found elements for A/B Tests:", testVariantGroups);
        // Randomly select and display one variant from each group
        testVariantGroups.forEach(function (testVariantGroup, userFriendlyTestId) {
            var abTest = abTests === null || abTests === void 0 ? void 0 : abTests.find(function (abTest) { return abTest.test.userFriendlyId === userFriendlyTestId; });
            log(logScope, "Handling A/B test with userFriendlyId: ".concat(userFriendlyTestId, "."));
            if (abTest && !abTest.eligible) {
                log(logScope, "Test is not eligable bacause: ".concat(abTest.reason));
            }
            var selectedVariantElements = [];
            var mainVariant = abTest === null || abTest === void 0 ? void 0 : abTest.test.variants.find(function (variant) { return variant.main; });
            var mainVariantElements = testVariantGroup.filter(function (variant) {
                return (mainVariant === null || mainVariant === void 0 ? void 0 : mainVariant.userFriendlyId) &&
                    variant.getAttribute('data-optibase-variant-id') ===
                        mainVariant.userFriendlyId;
            });
            var forcedVariantsElements = testVariantGroup.filter(function (variant) {
                return forcedVariants.some(function (forcedVariant) {
                    return variant.getAttribute('data-optibase-variant-id') ===
                        forcedVariant.userFriendlyVariantId &&
                        userFriendlyTestId === forcedVariant.userFriendlyTestId;
                });
            });
            var previewVariantElements = testVariantGroup.filter(function (variant) {
                return ((previewVariant === null || previewVariant === void 0 ? void 0 : previewVariant.userFriendlyVariantId) &&
                    variant.getAttribute('data-optibase-variant-id') ===
                        previewVariant.userFriendlyVariantId &&
                    (abTest === null || abTest === void 0 ? void 0 : abTest.test.userFriendlyId) === (previewVariant === null || previewVariant === void 0 ? void 0 : previewVariant.userFriendlyTestId));
            });
            var winnerVariantElements = testVariantGroup.filter(function (variant) {
                return ((abTest === null || abTest === void 0 ? void 0 : abTest.test.winnerVariantFriendlyId) &&
                    variant.getAttribute('data-optibase-variant-id') ===
                        abTest.test.winnerVariantFriendlyId);
            });
            var dontPushVariant = false;
            if (previewVariantElements.length) {
                log(logScope, "Selecting the preview variant.");
                dontPushVariant = true;
                selectedVariantElements = previewVariantElements;
            }
            else if (forcedVariantsElements.length) {
                log(logScope, "Selecting the forced variant.");
                selectedVariantElements = forcedVariantsElements;
            }
            else if (scriptDisabled && mainVariantElements.length) {
                log(logScope, "Selecting the main variant by default because the script is disabled.");
                dontPushVariant = true;
                selectedVariantElements = mainVariantElements;
            }
            else if (winnerVariantElements.length) {
                log(logScope, "Selecting the winner variant.");
                dontPushVariant = true;
                selectedVariantElements = winnerVariantElements;
            }
            else if (!(abTest === null || abTest === void 0 ? void 0 : abTest.eligible) && mainVariantElements.length) {
                log(logScope, "Selecting the main variant because test is not eligible.");
                dontPushVariant = true;
                selectedVariantElements = mainVariantElements;
            }
            else {
                var shownBeforeVariant_1 = abTest === null || abTest === void 0 ? void 0 : abTest.test.variants.find(function (variant) { return variant.shownBefore; });
                var shownBeforeVariantElements = testVariantGroup.filter(function (variant) {
                    return variant.getAttribute('data-optibase-variant-id') ===
                        (shownBeforeVariant_1 === null || shownBeforeVariant_1 === void 0 ? void 0 : shownBeforeVariant_1.userFriendlyId);
                });
                if (shownBeforeVariantElements.length) {
                    selectedVariantElements = shownBeforeVariantElements;
                }
                else {
                    var randomNumber = generateSeededRandomNumber();
                    // Get unique variant IDs from elements
                    var uniqueVariantIds = Array.from(new Set(testVariantGroup.map(function (element) {
                        return element.getAttribute('data-optibase-variant-id');
                    })));
                    // Map unique variant IDs to their weights (not elements!)
                    var userFriendlyVariantIdsWithWeights = uniqueVariantIds.map(function (userFriendlyVariantId) {
                        var variant = abTest === null || abTest === void 0 ? void 0 : abTest.test.variants.find(function (variant) { return variant.userFriendlyId === userFriendlyVariantId; });
                        return {
                            userFriendlyVariantId: userFriendlyVariantId,
                            trafficSplitWeight: (variant === null || variant === void 0 ? void 0 : variant.trafficSplitWeight) || 0,
                        };
                    });
                    log(logScope, "Selecting random variant from ".concat(uniqueVariantIds.length, " unique variants:"), userFriendlyVariantIdsWithWeights);
                    var randomUserFriendlyVariantId_1 = selectRandomWeightedVariant(userFriendlyVariantIdsWithWeights, randomNumber).userFriendlyVariantId;
                    log(logScope, "Selected random variant:", randomUserFriendlyVariantId_1);
                    selectedVariantElements = testVariantGroup.filter(function (variant) {
                        return variant.getAttribute('data-optibase-variant-id') ===
                            randomUserFriendlyVariantId_1;
                    });
                }
            }
            var userFriendlyVariantId = selectedVariantElements[0].getAttribute('data-optibase-variant-id');
            log(logScope, "Selected variant with userFriendlyVariantId: ".concat(userFriendlyVariantId, ". Elements:"), selectedVariantElements);
            if (!previewVariant &&
                !scriptDisabled &&
                (abTest === null || abTest === void 0 ? void 0 : abTest.eligible) &&
                !dontPushVariant &&
                !fromCached) {
                shownVariants.push({
                    userFriendlyTestId: userFriendlyTestId,
                    userFriendlyVariantId: userFriendlyVariantId,
                });
            }
            if (!scriptDisabled) {
                var selectedVariantData = abTest === null || abTest === void 0 ? void 0 : abTest.test.variants.find(function (v) { return v.userFriendlyId === userFriendlyVariantId; });
                if (selectedVariantData) {
                    injectVariantCustomCode(userFriendlyTestId, userFriendlyVariantId, selectedVariantData.customCss, selectedVariantData.customJs, fromCached);
                }
            }
            // Make them visible again
            for (var _i = 0, selectedVariantElements_1 = selectedVariantElements; _i < selectedVariantElements_1.length; _i++) {
                var selectedVariantElement = selectedVariantElements_1[_i];
                showOptibaseVariantElement(selectedVariantElement);
            }
            for (var _a = 0, testVariantGroup_1 = testVariantGroup; _a < testVariantGroup_1.length; _a++) {
                var element = testVariantGroup_1[_a];
                var elementUserFriendlyVariantId = element.getAttribute('data-optibase-variant-id');
                if (elementUserFriendlyVariantId !== userFriendlyVariantId) {
                    if (fromCached) {
                        element.style.display = 'none';
                    }
                    else {
                        element.remove();
                    }
                }
            }
        });
    }
    // Executes personalizations by showing the appropriate variant based on server-evaluated audience rules
    function handlePersonalizations(personalizations, fromCached, previewVariant, forcedVariants) {
        var logScope = fromCached
            ? 'handlePersonalizations cached'
            : 'handlePersonalizations';
        log(logScope, "Handling Personalizations personalizations:", personalizations, ' fromCached:', fromCached);
        var elements = document.querySelectorAll('[data-optibase-personalization-id]');
        if (elements.length === 0) {
            log(logScope, "No elements with personalization attributes found.");
            return;
        }
        var personalizationVariantGroups = new Map();
        elements.forEach(function (el) {
            var userFriendlyPersonalizationId = el.getAttribute('data-optibase-personalization-id');
            var userFriendlyVariantId = el.getAttribute('data-optibase-variant-id');
            if (!userFriendlyPersonalizationId) {
                return;
            }
            if (!userFriendlyVariantId) {
                console.error("[Optibase] Error: Element on the site missing 'data-optibase-variant-id' attribute. Personalization ID: ".concat(userFriendlyPersonalizationId));
                return;
            }
            var personalization = personalizations === null || personalizations === void 0 ? void 0 : personalizations.find(function (p) { return p.test.userFriendlyId === userFriendlyPersonalizationId; });
            if (!personalization) {
                if (!fromCached) {
                    console.error("[Optibase] Error: Element on the site is not part of any personalization. Invalid Personalization ID: ".concat(userFriendlyPersonalizationId));
                }
                return;
            }
            if (!personalization.test.variants.find(function (variant) { return variant.userFriendlyId === userFriendlyVariantId; })) {
                if (fromCached) {
                    console.error("[Optibase] Error: Element on the site is not part of any personalization. Invalid Variant ID: ".concat(userFriendlyVariantId));
                }
                return;
            }
            if (!personalizationVariantGroups.has(userFriendlyPersonalizationId)) {
                personalizationVariantGroups.set(userFriendlyPersonalizationId, []);
            }
            personalizationVariantGroups.get(userFriendlyPersonalizationId).push(el);
        });
        log(logScope, "Found elements for Personalizations:", personalizationVariantGroups);
        personalizationVariantGroups.forEach(function (personalizationVariantGroup, userFriendlyPersonalizationId) {
            var _a;
            var personalization = personalizations === null || personalizations === void 0 ? void 0 : personalizations.find(function (p) { return p.test.userFriendlyId === userFriendlyPersonalizationId; });
            if (!personalization) {
                console.error("[Optibase] Error: Personalization ".concat(userFriendlyPersonalizationId, " not found in personalizations array"));
                return;
            }
            log(logScope, "Handling personalization with userFriendlyId: ".concat(userFriendlyPersonalizationId, "."));
            if (personalization && !personalization.eligible) {
                log(logScope, "Personalization is not eligible because: ".concat(personalization.reason));
            }
            var selectedVariantElements = [];
            if (personalization.test.variants.length !== 2) {
                console.error("[Optibase] Error: Personalization must have exactly 2 variants. Found ".concat(personalization.test.variants.length, "."));
                return;
            }
            var mainVariant = personalization.test.variants.find(function (v) {
                return v.userFriendlyId.includes('main_variant') ||
                    v.userFriendlyId.endsWith('_main');
            }) || personalization.test.variants[0];
            var personalizedVariant = personalization.test.variants.find(function (v) {
                return v.userFriendlyId.includes('personalized_variant') ||
                    v.userFriendlyId.endsWith('_personalized');
            }) || personalization.test.variants[1];
            if (!mainVariant || !personalizedVariant) {
                console.error("[Optibase] Error: Could not identify main and personalized variants for ".concat(userFriendlyPersonalizationId, ". Variant IDs: ").concat(personalization.test.variants.map(function (v) { return v.userFriendlyId; }).join(', ')));
                return;
            }
            if (mainVariant.userFriendlyId === personalizedVariant.userFriendlyId) {
                console.error("[Optibase] Error: Main and personalized variants have the same ID for ".concat(userFriendlyPersonalizationId));
                return;
            }
            var mainVariantElements = personalizationVariantGroup.filter(function (variant) {
                return variant.getAttribute('data-optibase-variant-id') ===
                    mainVariant.userFriendlyId;
            });
            var personalizedVariantElements = personalizationVariantGroup.filter(function (variant) {
                return variant.getAttribute('data-optibase-variant-id') ===
                    personalizedVariant.userFriendlyId;
            });
            // Check if user has already seen a variant for this personalization
            var shownBeforeVariant = personalization.test.variants.find(function (variant) { return variant.shownBefore; });
            var shownBeforeVariantElements = shownBeforeVariant
                ? personalizationVariantGroup.filter(function (variant) {
                    return variant.getAttribute('data-optibase-variant-id') ===
                        shownBeforeVariant.userFriendlyId;
                })
                : [];
            var forcedVariantsElements = personalizationVariantGroup.filter(function (variant) {
                return forcedVariants.some(function (forcedVariant) {
                    return variant.getAttribute('data-optibase-variant-id') ===
                        forcedVariant.userFriendlyVariantId &&
                        userFriendlyPersonalizationId ===
                            forcedVariant.userFriendlyTestId;
                });
            });
            var previewVariantElements = personalizationVariantGroup.filter(function (variant) {
                return ((previewVariant === null || previewVariant === void 0 ? void 0 : previewVariant.userFriendlyVariantId) &&
                    variant.getAttribute('data-optibase-variant-id') ===
                        previewVariant.userFriendlyVariantId &&
                    (personalization === null || personalization === void 0 ? void 0 : personalization.test.userFriendlyId) ===
                        (previewVariant === null || previewVariant === void 0 ? void 0 : previewVariant.userFriendlyTestId));
            });
            var dontPushVariant = false;
            if (previewVariantElements.length) {
                log(logScope, "Selecting the preview variant.");
                dontPushVariant = true;
                selectedVariantElements = previewVariantElements;
            }
            else if (forcedVariantsElements.length) {
                log(logScope, "Selecting the forced variant.");
                selectedVariantElements = forcedVariantsElements;
            }
            else if (scriptDisabled && mainVariantElements.length) {
                log(logScope, "Selecting the main variant by default because the script is disabled.");
                dontPushVariant = true;
                selectedVariantElements = mainVariantElements;
            }
            else if (!(personalization === null || personalization === void 0 ? void 0 : personalization.eligible) && mainVariantElements.length) {
                log(logScope, "Selecting the main variant because personalization is not eligible.");
                dontPushVariant = true;
                selectedVariantElements = mainVariantElements;
            }
            else if (shownBeforeVariantElements.length) {
                log(logScope, "Selecting the previously shown variant: ".concat(shownBeforeVariant === null || shownBeforeVariant === void 0 ? void 0 : shownBeforeVariant.userFriendlyId));
                selectedVariantElements = shownBeforeVariantElements;
            }
            else {
                // Audience rules already evaluated server-side - if eligible, show personalized variant
                if (personalizedVariantElements.length > 0) {
                    selectedVariantElements = personalizedVariantElements;
                    log(logScope, "".concat(userFriendlyPersonalizationId, " - Eligible, showing personalized variant."));
                }
                else {
                    console.warn("[Optibase] Warning: Personalization ".concat(userFriendlyPersonalizationId, " is eligible but no personalized variant elements found on page. Falling back to main variant."));
                    selectedVariantElements = mainVariantElements;
                }
            }
            if (selectedVariantElements.length === 0) {
                log(logScope, "".concat(userFriendlyPersonalizationId, " - No variant elements found. Showing main variant as fallback."));
                selectedVariantElements = mainVariantElements;
            }
            var userFriendlyVariantId = ((_a = selectedVariantElements[0]) === null || _a === void 0 ? void 0 : _a.getAttribute('data-optibase-variant-id')) || mainVariant.userFriendlyId;
            log(logScope, "Selected variant with userFriendlyVariantId: ".concat(userFriendlyVariantId, ". Elements:"), selectedVariantElements);
            if (!previewVariant &&
                !scriptDisabled &&
                (personalization === null || personalization === void 0 ? void 0 : personalization.eligible) &&
                !dontPushVariant &&
                !fromCached) {
                shownVariants.push({
                    userFriendlyTestId: userFriendlyPersonalizationId,
                    userFriendlyVariantId: userFriendlyVariantId,
                });
            }
            if (!scriptDisabled) {
                var selectedVariantData = personalization === null || personalization === void 0 ? void 0 : personalization.test.variants.find(function (v) { return v.userFriendlyId === userFriendlyVariantId; });
                if (selectedVariantData) {
                    injectVariantCustomCode(userFriendlyPersonalizationId, userFriendlyVariantId, selectedVariantData.customCss, selectedVariantData.customJs, fromCached);
                }
            }
            for (var _i = 0, selectedVariantElements_2 = selectedVariantElements; _i < selectedVariantElements_2.length; _i++) {
                var selectedVariantElement = selectedVariantElements_2[_i];
                showOptibaseVariantElement(selectedVariantElement);
            }
            for (var _b = 0, personalizationVariantGroup_1 = personalizationVariantGroup; _b < personalizationVariantGroup_1.length; _b++) {
                var element = personalizationVariantGroup_1[_b];
                var elementUserFriendlyVariantId = element.getAttribute('data-optibase-variant-id');
                if (elementUserFriendlyVariantId !== userFriendlyVariantId) {
                    if (fromCached) {
                        element.style.display = 'none';
                    }
                    else {
                        element.remove();
                    }
                }
            }
        });
    }
    /**
     * Sends an event to the Optibase API for tracking conversions.
     * @param isEngagementConversion - Whether this is an engagement conversion (user action).
     *        Only engagement conversions prevent a bounce. PAGE_VIEW and TIME_ON_PAGE are not engagement conversions.
     */
    function sendConversionEvent(userFriendlyConversionId_1) {
        return __awaiter(this, arguments, void 0, function (userFriendlyConversionId, isEngagementConversion) {
            var conversionEventBody, response, responseJson_2, responseText, responseJson, error_1;
            if (isEngagementConversion === void 0) { isEngagementConversion = true; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!publicApiKey) {
                            throw new Error('[Optibase] publicApiKey is undefined');
                        }
                        if (!testedUserId) {
                            throw new Error('[Optibase] testedUserId is undefined');
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        conversionEventBody = {
                            publicApiKey: publicApiKey,
                            testedUserId: testedUserId,
                            userFriendlyConversionId: userFriendlyConversionId,
                            originUrl: currentOriginUrl,
                            samePageVariants: shownVariants,
                        };
                        log('sendConversionEvent', "Calling with body:", conversionEventBody);
                        return [4 /*yield*/, fetch("".concat(baseApiUrl, "/api/script/conversionEvent"), {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify(conversionEventBody),
                            }).catch(function (error) {
                                // Don't surface the error to Sentry because
                                // it's usually a network error
                                console.error("[Optibase] Error occurred while fetching conversionEvent. Details:", error);
                            })];
                    case 2:
                        response = _a.sent();
                        if (!response) {
                            return [2 /*return*/];
                        }
                        if (!!response.ok) return [3 /*break*/, 5];
                        return [4 /*yield*/, response.json().catch(function () { })];
                    case 3:
                        responseJson_2 = _a.sent();
                        return [4 /*yield*/, response.text().catch(function () { })];
                    case 4:
                        responseText = _a.sent();
                        if (response.status === 400 && !responseJson_2.clientError) {
                            // This means it was a user error, like running on
                            // a non valid domain
                            throw new OptibaseUserError('[Optibase] Response not ok when calling conversionEvent: ' +
                                (responseJson_2 === null || responseJson_2 === void 0 ? void 0 : responseJson_2.message) ||
                                responseText ||
                                'Unknown error');
                        }
                        else if (response.status === 500) {
                            // This means it was an error on the server, don't surface to Sentry
                            throw new OptibaseUserError('[Optibase] Response not ok when calling conversionEvent: ' +
                                (responseJson_2 === null || responseJson_2 === void 0 ? void 0 : responseJson_2.message) ||
                                responseText ||
                                'Internal Server Error');
                        }
                        else {
                            throw new Error('[Optibase] Response not ok when calling conversionEvent: ' +
                                (responseJson_2 === null || responseJson_2 === void 0 ? void 0 : responseJson_2.message) ||
                                responseText ||
                                'Unknown error');
                        }
                        _a.label = 5;
                    case 5: return [4 /*yield*/, response.json()];
                    case 6:
                        responseJson = _a.sent();
                        log('sendConversionEvent', "Response: ", responseJson);
                        if (responseJson === null || responseJson === void 0 ? void 0 : responseJson.bot) {
                            return [2 /*return*/];
                        }
                        // Mark that a conversion occurred (for bounce tracking)
                        hadConversion = true;
                        if (isEngagementConversion) {
                            hadEngagementConversion = true;
                        }
                        if (amplitudeEnabled && isAmplitudeInstalled()) {
                            // @ts-ignore
                            window.amplitude.track('optibase_conversion_triggered', {
                                conversionId: userFriendlyConversionId,
                            });
                        }
                        return [3 /*break*/, 8];
                    case 7:
                        error_1 = _a.sent();
                        if (!(error_1 instanceof OptibaseUserError)) {
                            optibaseSentryClient === null || optibaseSentryClient === void 0 ? void 0 : optibaseSentryClient.captureException(error_1);
                        }
                        console.error("[Optibase] Error occurred while sending a conversion event. Details:", error_1);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
    function isGA4Installed() {
        return typeof window.gtag === 'function';
    }
    function isDataLayerInstalled() {
        return Array.isArray(window.dataLayer);
    }
    // Send variant information to GA4
    function sendVariantToGA4(shownVariant, destination) {
        var _a, _b;
        var eventLabel = shownVariant.userFriendlyTestId + ':' + shownVariant.userFriendlyVariantId;
        if (destination === 'gtag') {
            log('sendVariantToGA4', "Sending variant ".concat(eventLabel, " to GA4 via gtag."));
            (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, 'event', 'optibase_variant_shown', {
                event_category: 'optibase',
                event_label: eventLabel,
            });
            return;
        }
        log('sendVariantToGA4', "Sending variant ".concat(eventLabel, " to GA4 via dataLayer."));
        (_b = window.dataLayer) === null || _b === void 0 ? void 0 : _b.push({
            event: 'optibase_variant_shown',
            event_category: 'optibase',
            event_label: eventLabel,
            optibase_test_id: shownVariant.userFriendlyTestId,
            optibase_variant_id: shownVariant.userFriendlyVariantId,
        });
    }
    // Function to check if Mixpanel is installed
    function isMixpanelInstalled() {
        return (
        // @ts-ignore
        typeof mixpanel !== 'undefined' && typeof mixpanel.track === 'function');
    }
    // Send variant information to Mixpanel
    // where name of the event property is optibase_userFriendlyTestId
    // and value of the event property is optibase_userFriendlyVariantId
    function sendVariantToMixpanel(shownVariant) {
        log('sendVariantToMixpanel', "Sending variant ".concat(shownVariant.userFriendlyTestId +
            ':' +
            shownVariant.userFriendlyVariantId, " to Mixpanel."));
        // @ts-ignore
        mixpanel.track('optibase_variant_shown', {
            testId: shownVariant.userFriendlyTestId,
            variantId: shownVariant.userFriendlyTestId +
                ':' +
                shownVariant.userFriendlyVariantId,
        });
    }
    // Checks that Amplitude (@amplitude/analytics-browser) is loaded and initialized.
    function isAmplitudeInstalled() {
        // @ts-ignore
        var amp = window.amplitude;
        return (typeof amp !== 'undefined' &&
            typeof amp.identify === 'function' &&
            typeof amp.Identify === 'function' &&
            (typeof amp.isInitializedAndEnabled !== 'function' ||
                amp.isInitializedAndEnabled()));
    }
    // Sets variant as an Amplitude user property and logs an optibase_variant_shown event.
    // The customer's own Amplitude SDK handles the API calls — the API key stays server-side.
    function sendVariantToAmplitude(shownVariant) {
        log('sendVariantToAmplitude', "Sending variant ".concat(shownVariant.userFriendlyTestId, ":").concat(shownVariant.userFriendlyVariantId, " to Amplitude."));
        // @ts-ignore
        var amp = window.amplitude;
        var identify = new amp.Identify();
        identify.set("Optibase-Test-".concat(shownVariant.userFriendlyTestId), shownVariant.userFriendlyVariantId);
        amp.identify(identify);
        amp.track('optibase_variant_shown', {
            testId: shownVariant.userFriendlyTestId,
            variantId: shownVariant.userFriendlyVariantId,
        });
    }
    /**
     * Sends an View to the Optibase API.
     */
    function sendView(timeToSetup) {
        return __awaiter(this, void 0, void 0, function () {
            var isBusinessOrProPlan, currentBrowser_1, currentOS_1, currentScreenSize_1, viewBody, response, responseJson_3, responseText, responseJson, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Guard: Don't send view events if tracking is not enabled
                        if (!trackingEnabled) {
                            log('sendView', 'Tracking not enabled, skipping view event');
                            return [2 /*return*/];
                        }
                        isBusinessOrProPlan = isBusinessTierPlan();
                        if (shownVariants.length === 0 && !isBusinessOrProPlan) {
                            log('sendView', "No variants to send. Time to setup: ".concat(timeToSetup, "ms."));
                            return [2 /*return*/];
                        }
                        if (!publicApiKey) {
                            throw new Error('[Optibase] publicApiKey is undefined');
                        }
                        if (!testedUserId) {
                            throw new Error('[Optibase] testedUserId is undefined');
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        currentBrowser_1 = getCurrentBrowser();
                        currentOS_1 = getCurrentOS();
                        currentScreenSize_1 = getCurrentScreenSize();
                        viewBody = {
                            publicApiKey: publicApiKey,
                            testedUserId: testedUserId,
                            variants: shownVariants,
                            originUrl: currentOriginUrl,
                            screenSize: currentScreenSize_1,
                            OS: currentOS_1,
                            browser: currentBrowser_1,
                            timeToSetup: timeToSetup,
                        };
                        window.optibaseActiveVariants = shownVariants;
                        optibaseActiveVariantsListeners.forEach(function (listener) {
                            return invokeActiveVariantsListener(listener, shownVariants);
                        });
                        // Send events to GA4, preferring gtag over dataLayer to avoid duplicates.
                        runExternalCallback('GA4', function () {
                            var ga4Destination = isGA4Installed()
                                ? 'gtag'
                                : isDataLayerInstalled()
                                    ? 'dataLayer'
                                    : null;
                            if (ga4Destination) {
                                shownVariants.forEach(function (shownVariant) {
                                    runExternalCallback('GA4 variant', function () {
                                        sendVariantToGA4(shownVariant, ga4Destination);
                                    });
                                });
                            }
                            else {
                                log('sendVariantToGA4', 'Neither Google Analytics (GA4) gtag nor GTM dataLayer is available.');
                            }
                        });
                        // Send events to Mixpanel
                        runExternalCallback('Mixpanel', function () {
                            if (isMixpanelInstalled()) {
                                shownVariants.forEach(function (shownVariant) {
                                    runExternalCallback('Mixpanel variant', function () {
                                        sendVariantToMixpanel(shownVariant);
                                    });
                                });
                            }
                            else {
                                log('sendVariantToMixpanel', 'Mixpanel is not installed.');
                            }
                        });
                        // Send variant assignments to Amplitude
                        runExternalCallback('Amplitude', function () {
                            if (amplitudeEnabled) {
                                if (isAmplitudeInstalled()) {
                                    shownVariants.forEach(function (shownVariant) {
                                        runExternalCallback('Amplitude variant', function () {
                                            sendVariantToAmplitude(shownVariant);
                                        });
                                    });
                                }
                                else {
                                    log('sendVariantToAmplitude', 'Amplitude SDK not found on page.');
                                }
                            }
                            else if (isAmplitudeInstalled()) {
                                log('sendVariantToAmplitude', 'Amplitude detected but not connected in Optibase. Go to Settings → Integrations to enable it.');
                            }
                        });
                        log('sendView', "Calling with body:", viewBody);
                        return [4 /*yield*/, fetch("".concat(baseApiUrl, "/api/script/view"), {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify(viewBody),
                            }).catch(function (error) {
                                // Don't surface the error to Sentry because
                                // it's usually a network error
                                console.error("[Optibase] Error occurred while fetching view. Details:", error);
                            })];
                    case 2:
                        response = _a.sent();
                        if (!response) {
                            return [2 /*return*/];
                        }
                        if (!!response.ok) return [3 /*break*/, 5];
                        return [4 /*yield*/, response.json().catch(function () { })];
                    case 3:
                        responseJson_3 = _a.sent();
                        return [4 /*yield*/, response.text().catch(function () { })];
                    case 4:
                        responseText = _a.sent();
                        if (response.status === 400 && !responseJson_3.clientError) {
                            // This means it was a user error, like running on
                            // a non valid domain
                            throw new OptibaseUserError('[Optibase] Response not ok when calling view: ' +
                                (responseJson_3 === null || responseJson_3 === void 0 ? void 0 : responseJson_3.message) ||
                                responseText ||
                                'Unknown error');
                        }
                        else if (response.status === 500) {
                            // This means it was an error on the server, don't surface to Sentry
                            throw new OptibaseUserError('[Optibase] Response not ok when calling view: ' +
                                (responseJson_3 === null || responseJson_3 === void 0 ? void 0 : responseJson_3.message) ||
                                responseText ||
                                'Internal Server Error');
                        }
                        else {
                            throw new Error('[Optibase] Response not ok when calling view: ' +
                                (responseJson_3 === null || responseJson_3 === void 0 ? void 0 : responseJson_3.message) ||
                                responseText ||
                                'Unknown error');
                        }
                        _a.label = 5;
                    case 5: return [4 /*yield*/, response.json()];
                    case 6:
                        responseJson = _a.sent();
                        log('sendView', "Response:", responseJson);
                        if (responseJson === null || responseJson === void 0 ? void 0 : responseJson.bot) {
                            return [2 /*return*/];
                        }
                        // Store viewId for bounce tracking
                        if (responseJson.viewId) {
                            currentViewId = responseJson.viewId;
                            pageLoadTime = Date.now();
                            hadConversion = false;
                            hadEngagementConversion = false;
                            bounceSent = false;
                            maxScrollDepth = 0;
                            // Set up bounce tracking listeners
                            setupBounceTracking();
                        }
                        return [3 /*break*/, 8];
                    case 7:
                        error_2 = _a.sent();
                        if (!(error_2 instanceof OptibaseUserError)) {
                            optibaseSentryClient === null || optibaseSentryClient === void 0 ? void 0 : optibaseSentryClient.captureException(error_2);
                        }
                        console.error("[Optibase] Error occurred while sending a View. Details:", error_2);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
    /**
     * Sends bounce data to the server when the user leaves the page.
     * Uses sendBeacon for reliability during page unload.
     */
    function sendBounce() {
        // Guard: Don't send bounce events if tracking is not enabled
        if (!trackingEnabled) {
            log('sendBounce', 'Tracking not enabled, skipping bounce event');
            return;
        }
        if (bounceSent) {
            log('sendBounce', 'Bounce already sent, skipping.');
            return;
        }
        if (!currentViewId) {
            log('sendBounce', 'No viewId available, skipping bounce tracking.');
            return;
        }
        if (!publicApiKey || !testedUserId) {
            log('sendBounce', 'Missing publicApiKey or testedUserId, skipping.');
            return;
        }
        bounceSent = true;
        var timeOnPage = Date.now() - pageLoadTime;
        var bounceBody = {
            publicApiKey: publicApiKey,
            testedUserId: testedUserId,
            viewId: currentViewId,
            timeOnPage: timeOnPage,
            hadConversion: hadConversion,
            hadEngagementConversion: hadEngagementConversion,
            variants: shownVariants,
            scrollDepth: Math.round(maxScrollDepth),
        };
        log('sendBounce', "Sending bounce data:", bounceBody);
        // Use sendBeacon for reliability during page unload
        // Must use Blob with correct Content-Type for server to parse JSON
        var blob = new Blob([JSON.stringify(bounceBody)], {
            type: 'application/json',
        });
        var success = navigator.sendBeacon("".concat(baseApiUrl, "/api/script/bounce"), blob);
        if (!success) {
            log('sendBounce', 'sendBeacon failed, attempting fetch.');
            // Fallback to fetch (may not complete during unload)
            fetch("".concat(baseApiUrl, "/api/script/bounce"), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(bounceBody),
                keepalive: true,
            }).catch(function (error) {
                log('sendBounce', 'Fetch fallback also failed:', error);
            });
        }
    }
    /**
     * Sets up event listeners to track when the user leaves/closes the page.
     * Only tracks actual page close/navigation, not tab switches.
     */
    function setupBounceTracking() {
        log('setupBounceTracking', 'Setting up bounce tracking listeners.');
        // Track max scroll depth for analytics
        window.addEventListener('scroll', function () {
            var depth = getScrollDepth();
            if (depth > maxScrollDepth)
                maxScrollDepth = depth;
        }, { passive: true });
        // pagehide fires when user navigates away or closes the page
        window.addEventListener('pagehide', function () {
            log('setupBounceTracking', 'Page hide event.');
            sendBounce();
        });
        // beforeunload as a fallback for older browsers
        window.addEventListener('beforeunload', function () {
            log('setupBounceTracking', 'Before unload event.');
            sendBounce();
        });
    }
    function handleClickConversions(clickConversions) {
        log('handleClickConversions', "Setting up click listeners.");
        // Select all elements with a click conversion ID attribute
        var clickableElements = document.querySelectorAll('[data-optibase-click-conversion-id]');
        if (clickableElements.length === 0) {
            log('handleClickConversions', "No elements with click conversion attribute found.");
            return;
        }
        log('handleClickConversions', "Found elements with click conversion attribute:", clickableElements);
        // Attach click event listeners to each found element
        clickableElements.forEach(function (element) {
            var clickConversionId = element.getAttribute('data-optibase-click-conversion-id');
            if (!clickConversions.find(function (conversion) { return conversion.userFriendlyId === clickConversionId; })) {
                console.error("[Optibase] Error: Element with click conversion ID \"".concat(clickConversionId, "\" does not have a corresponding Click Conversion on the server."));
                return;
            }
            element.addEventListener('click', function (event) {
                return __awaiter(this, void 0, void 0, function () {
                    var anchorElement, url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(element.tagName === 'A')) return [3 /*break*/, 2];
                                event.preventDefault();
                                return [4 /*yield*/, sendConversionEvent(clickConversionId)];
                            case 1:
                                _a.sent();
                                anchorElement = element;
                                url = anchorElement.href // Get the href value from the <a> element
                                ;
                                if (url) {
                                    if (anchorElement.target === '_blank') {
                                        // If the target is '_blank', open the URL in a new tab
                                        window.open(url, '_blank');
                                    }
                                    else {
                                        // Otherwise, navigate in the current tab/window
                                        window.location.href = url;
                                    }
                                }
                                return [3 /*break*/, 3];
                            case 2:
                                sendConversionEvent(clickConversionId);
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            });
        });
    }
    function handleSubmitConversions(submitConversions) {
        log('handleSubmitConversions', "Setting up submit listeners.");
        // Select all form elements with a submit conversion ID attribute
        var submitableElements = document.querySelectorAll('[data-optibase-submit-conversion-id]');
        if (submitableElements.length === 0) {
            log('handleSubmitConversions', "No elements with submit conversion attribute found.");
            return;
        }
        log('handleSubmitConversions', "Found elements with submit conversion attribute:", submitableElements);
        // Attach submit event listeners to each found form element
        submitableElements.forEach(function (element) {
            var submitConversionId = element.getAttribute('data-optibase-submit-conversion-id');
            if (!submitConversions.find(function (conversion) { return conversion.userFriendlyId === submitConversionId; })) {
                console.error("[Optibase] Error: Element with submit conversion ID \"".concat(submitConversionId, "\" does not have a corresponding Submit Conversion on the server."));
                return;
            }
            if (isCalendlyEmbedElement(element)) {
                registerCalendlySubmitConversion(element, submitConversionId);
                return;
            }
            if (isHubSpotEmbedElement(element)) {
                registerHubSpotSubmitConversion(element, submitConversionId);
                return;
            }
            function handleSubmitEvent(event) {
                return __awaiter(this, void 0, void 0, function () {
                    var formElement;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                log('handleSubmitConversions', "Handling submit event for conversion ID \"".concat(submitConversionId, "\"."));
                                if (!(element.getAttribute('action') && !event.defaultPrevented)) return [3 /*break*/, 2];
                                event.preventDefault();
                                return [4 /*yield*/, sendConversionEvent(submitConversionId)];
                            case 1:
                                _a.sent();
                                formElement = element;
                                formElement.submit();
                                return [3 /*break*/, 3];
                            case 2:
                                sendConversionEvent(submitConversionId);
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            }
            // If the element is not a form, it's probably an embed
            // and we need to wait for the form to be added to the DOM
            if (element.tagName !== 'FORM') {
                log('handleSubmitConversions', "Element with submit conversion ID \"".concat(submitConversionId, "\" is not a form element. Waiting for form to be added to the DOM by adding an observer."));
                var lookForForm_1 = function () {
                    // Handle elements that are divs that include an iframe that include a form element
                    var form = element.querySelector('form');
                    if (!form) {
                        var iframe = element.querySelector('iframe');
                        if (!iframe) {
                            log('handleSubmitConversions', "Element with submit conversion ID \"".concat(submitConversionId, "\" is not a form element, does not contain a form element, and is not an iframe."));
                            return;
                        }
                        var iframeDocument = iframe.contentDocument;
                        if (!iframeDocument) {
                            log('handleSubmitConversions', "[Optibase] iframe in element with submit conversion ID \"".concat(submitConversionId, "\" does not have a contentDocument."));
                            return;
                        }
                        form = iframeDocument.querySelector('form');
                        if (!form) {
                            log('handleSubmitConversions', "[Optibase] iframe in element with submit conversion ID \"".concat(submitConversionId, "\" does not have a form element."));
                            return;
                        }
                    }
                    log('handleSubmitConversions', "Adding submit listener to the found form element for submit conversion ID \"".concat(submitConversionId, "\":"), form);
                    observer_1.disconnect();
                    form.addEventListener('submit', handleSubmitEvent);
                };
                var observer_1 = new MutationObserver(function (mutations) {
                    log('handleSubmitConversions MutationObserver', "Found Mutations for submit conversion ID \"".concat(submitConversionId, "\":"), mutations);
                    mutations.forEach(function (mutation) {
                        if (mutation.type == 'childList') {
                            lookForForm_1();
                        }
                    });
                });
                var config = {
                    childList: true,
                    subtree: true, // Add this line to observe changes in descendants
                };
                observer_1.observe(element, config);
                lookForForm_1();
            }
            else {
                log('handleSubmitConversions', "Adding submit listener to the found form element for submit conversion ID \"".concat(submitConversionId, "\":"), element);
                var form = element;
                form.addEventListener('submit', handleSubmitEvent);
            }
        });
    }
    function isCalendlyEmbedElement(element) {
        var _a;
        if (element.classList.contains('calendly-inline-widget') ||
            ((_a = element.getAttribute('data-url')) === null || _a === void 0 ? void 0 : _a.includes('calendly.com'))) {
            return true;
        }
        if (element.tagName === 'IFRAME' &&
            element.src.includes('calendly.com')) {
            return true;
        }
        return Boolean(findCalendlyIframe(element));
    }
    function findCalendlyIframe(element) {
        if (element.tagName === 'IFRAME') {
            var iframe = element;
            return iframe.src.includes('calendly.com') ? iframe : null;
        }
        return element.querySelector('iframe[src*="calendly.com"]');
    }
    function isCalendlyMessage(event) {
        var eventOrigin;
        try {
            eventOrigin = new URL(event.origin);
        }
        catch (_a) {
            return false;
        }
        var isCalendlyOrigin = eventOrigin.hostname === 'calendly.com' ||
            eventOrigin.hostname.endsWith('.calendly.com');
        if (!isCalendlyOrigin) {
            return false;
        }
        return Boolean(event.data &&
            typeof event.data === 'object' &&
            typeof event.data.event === 'string' &&
            event.data.event.startsWith('calendly.'));
    }
    function ensureCalendlyMessageListener() {
        var _this = this;
        if (calendlyMessageListenerRegistered) {
            return;
        }
        window.addEventListener('message', function (event) { return __awaiter(_this, void 0, void 0, function () {
            var matchingRegistration;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isCalendlyMessage(event)) {
                            return [2 /*return*/];
                        }
                        if (event.data.event !== 'calendly.event_scheduled') {
                            log('handleSubmitConversions Calendly', 'Ignoring Calendly event.', event);
                            return [2 /*return*/];
                        }
                        matchingRegistration = calendlySubmitRegistrations.find(function (registration) {
                            var _a;
                            if (registration.hasConverted) {
                                return false;
                            }
                            if (!registration.iframe) {
                                registration.iframe = findCalendlyIframe(registration.element);
                            }
                            return ((_a = registration.iframe) === null || _a === void 0 ? void 0 : _a.contentWindow) === event.source;
                        });
                        if (!matchingRegistration) return [3 /*break*/, 2];
                        matchingRegistration.hasConverted = true;
                        log('handleSubmitConversions Calendly', "Sending conversion event for Calendly submit conversion ID \"".concat(matchingRegistration.submitConversionId, "\"."));
                        return [4 /*yield*/, sendConversionEvent(matchingRegistration.submitConversionId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2:
                        log('handleSubmitConversions Calendly', 'Received calendly.event_scheduled but found no matching registration.');
                        return [2 /*return*/];
                }
            });
        }); });
        calendlyMessageListenerRegistered = true;
    }
    function registerCalendlySubmitConversion(element, submitConversionId) {
        log('handleSubmitConversions Calendly', "Registering Calendly submit conversion ID \"".concat(submitConversionId, "\"."), element);
        var existingRegistration = calendlySubmitRegistrations.find(function (registration) {
            return registration.element === element &&
                registration.submitConversionId === submitConversionId;
        });
        if (existingRegistration) {
            existingRegistration.iframe =
                existingRegistration.iframe || findCalendlyIframe(element);
            log('handleSubmitConversions Calendly', "Calendly submit conversion ID \"".concat(submitConversionId, "\" already registered."));
            return;
        }
        ensureCalendlyMessageListener();
        var registration = {
            element: element,
            submitConversionId: submitConversionId,
            iframe: findCalendlyIframe(element),
            observer: null,
            hasConverted: false,
        };
        if (!registration.iframe) {
            log('handleSubmitConversions Calendly', "Calendly iframe not found yet for submit conversion ID \"".concat(submitConversionId, "\". Waiting for iframe to be added."));
            registration.observer = new MutationObserver(function () {
                var _a;
                registration.iframe = findCalendlyIframe(element);
                if (registration.iframe) {
                    log('handleSubmitConversions Calendly', "Found Calendly iframe for submit conversion ID \"".concat(submitConversionId, "\"."), registration.iframe);
                    (_a = registration.observer) === null || _a === void 0 ? void 0 : _a.disconnect();
                    registration.observer = null;
                }
            });
            registration.observer.observe(element, {
                childList: true,
                subtree: true,
            });
        }
        calendlySubmitRegistrations.push(registration);
    }
    function isHubSpotEmbedElement(element) {
        if (element.hasAttribute('data-hs-forms-root') ||
            (element.hasAttribute('data-form-id') &&
                element.hasAttribute('data-portal-id')) ||
            element.classList.contains('hs-form-frame')) {
            log('handleSubmitConversions HubSpot', 'Detected HubSpot embed element.', element);
            return true;
        }
        var hasHubSpotForm = Boolean(element.querySelector('form[data-form-id][data-portal-id]'));
        if (hasHubSpotForm) {
            log('handleSubmitConversions HubSpot', 'Detected HubSpot form inside submit conversion element.', element);
        }
        return hasHubSpotForm;
    }
    function getHubSpotFormId(element) {
        var _a;
        var formId = element.getAttribute('data-form-id');
        if (formId) {
            return formId;
        }
        return ((_a = findHubSpotForm(element)) === null || _a === void 0 ? void 0 : _a.getAttribute('data-form-id')) || null;
    }
    function getHubSpotInstanceId(element) {
        var instanceId = element.getAttribute('data-instance-id');
        if (instanceId) {
            return instanceId;
        }
        var iframe = element.tagName === 'IFRAME'
            ? element
            : element.querySelector('iframe');
        if (!iframe) {
            return null;
        }
        try {
            return new URL(iframe.src).searchParams.get('_hsInstanceId');
        }
        catch (_a) {
            return null;
        }
    }
    function findHubSpotForm(element) {
        if (element.tagName === 'FORM' &&
            element.hasAttribute('data-form-id') &&
            element.hasAttribute('data-portal-id')) {
            return element;
        }
        return element.querySelector('form[data-form-id][data-portal-id]');
    }
    function isHubSpotMessageOrigin(origin) {
        var eventOrigin;
        try {
            eventOrigin = new URL(origin);
        }
        catch (_a) {
            return false;
        }
        return (eventOrigin.hostname === 'hubspot.com' ||
            eventOrigin.hostname.endsWith('.hubspot.com') ||
            eventOrigin.hostname === 'hsforms.com' ||
            eventOrigin.hostname.endsWith('.hsforms.com') ||
            eventOrigin.hostname === 'hsforms.net' ||
            eventOrigin.hostname.endsWith('.hsforms.net'));
    }
    function isSamePageHubSpotMessage(event) {
        // Inline HubSpot embeds (forms/embed/v2.js rendered directly into the
        // document) post their callbacks to the page's own window, so the message
        // origin is the page origin rather than a HubSpot domain.
        return event.origin === window.location.origin && event.source === window;
    }
    function isHubSpotSubmitMessage(event) {
        if (!isHubSpotMessageOrigin(event.origin) &&
            !isSamePageHubSpotMessage(event)) {
            return false;
        }
        var isHubSpotMessage = Boolean(event.data &&
            typeof event.data === 'object' &&
            event.data.type === 'hsFormCallback' &&
            event.data.eventName === 'onFormSubmitted');
        if (isHubSpotMessage) {
            log('handleSubmitConversions HubSpot', 'Received HubSpot submit message.', event.data);
        }
        return isHubSpotMessage;
    }
    function handleHubSpotSubmission(formId, instanceId, eventData) {
        return __awaiter(this, void 0, void 0, function () {
            var matchingRegistration;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        matchingRegistration = hubSpotSubmitRegistrations.find(function (registration) {
                            return !registration.hasConverted &&
                                registration.formId === formId &&
                                (!instanceId ||
                                    !registration.instanceId ||
                                    registration.instanceId === instanceId);
                        });
                        if (!matchingRegistration) {
                            log('handleSubmitConversions HubSpot', "Received HubSpot submission for form ID \"".concat(formId, "\" and instance ID \"").concat(instanceId, "\" but found no matching registration."), eventData);
                            return [2 /*return*/];
                        }
                        matchingRegistration.hasConverted = true;
                        log('handleSubmitConversions HubSpot', "Sending conversion event for HubSpot submit conversion ID \"".concat(matchingRegistration.submitConversionId, "\"."), eventData);
                        return [4 /*yield*/, sendConversionEvent(matchingRegistration.submitConversionId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function handleHubSpotSubmitError(error) {
        if (!(error instanceof OptibaseUserError)) {
            optibaseSentryClient === null || optibaseSentryClient === void 0 ? void 0 : optibaseSentryClient.captureException(error);
        }
        console.error('[Optibase] Error occurred while handling a HubSpot submit conversion. Details:', error);
    }
    function ensureHubSpotMessageListener() {
        var _this = this;
        if (hubSpotMessageListenerRegistered) {
            return;
        }
        window.addEventListener('message', function (event) { return __awaiter(_this, void 0, void 0, function () {
            var formId, instanceId, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isHubSpotSubmitMessage(event)) {
                            return [2 /*return*/];
                        }
                        formId = typeof event.data.id === 'string'
                            ? event.data.id
                            : typeof event.data.formId === 'string'
                                ? event.data.formId
                                : null;
                        instanceId = typeof event.data.instanceId === 'string' ? event.data.instanceId : null;
                        if (!formId) {
                            log('handleSubmitConversions HubSpot', 'Ignoring HubSpot submit message because it did not include a form ID.', event.data);
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, handleHubSpotSubmission(formId, instanceId, event.data)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        handleHubSpotSubmitError(error_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); });
        window.addEventListener('hs-form-event:on-submission:success', function (event) { return __awaiter(_this, void 0, void 0, function () {
            var hubSpotForm, customEvent, formId, instanceId, error_4;
            var _a, _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        log('handleSubmitConversions HubSpot', 'Received HubSpot Forms V4 submission success event.', event);
                        hubSpotForm = ((_b = (_a = window.HubSpotFormsV4) === null || _a === void 0 ? void 0 : _a.getFormFromEvent) === null || _b === void 0 ? void 0 : _b.call(_a, event)) || null;
                        customEvent = event;
                        formId = ((_c = hubSpotForm === null || hubSpotForm === void 0 ? void 0 : hubSpotForm.getFormId) === null || _c === void 0 ? void 0 : _c.call(hubSpotForm)) ||
                            (typeof ((_d = customEvent.detail) === null || _d === void 0 ? void 0 : _d.formId) === 'string'
                                ? customEvent.detail.formId
                                : null);
                        instanceId = ((_e = hubSpotForm === null || hubSpotForm === void 0 ? void 0 : hubSpotForm.getInstanceId) === null || _e === void 0 ? void 0 : _e.call(hubSpotForm)) ||
                            (typeof ((_f = customEvent.detail) === null || _f === void 0 ? void 0 : _f.instanceId) === 'string'
                                ? customEvent.detail.instanceId
                                : null);
                        if (!formId) {
                            log('handleSubmitConversions HubSpot', 'Ignoring HubSpot Forms V4 submission success event because it did not include a form ID.', event);
                            return [2 /*return*/];
                        }
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, handleHubSpotSubmission(formId, instanceId, event)];
                    case 2:
                        _g.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _g.sent();
                        handleHubSpotSubmitError(error_4);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); });
        window.addEventListener('hs-form-event:on-ready', function (event) {
            var _a, _b, _c, _d;
            log('handleSubmitConversions HubSpot', 'Received HubSpot Forms V4 ready event.', event);
            var hubSpotForm = (_b = (_a = window.HubSpotFormsV4) === null || _a === void 0 ? void 0 : _a.getFormFromEvent) === null || _b === void 0 ? void 0 : _b.call(_a, event);
            var formId = (_c = hubSpotForm === null || hubSpotForm === void 0 ? void 0 : hubSpotForm.getFormId) === null || _c === void 0 ? void 0 : _c.call(hubSpotForm);
            var instanceId = (_d = hubSpotForm === null || hubSpotForm === void 0 ? void 0 : hubSpotForm.getInstanceId) === null || _d === void 0 ? void 0 : _d.call(hubSpotForm);
            if (!formId) {
                return;
            }
            var matchingRegistration = hubSpotSubmitRegistrations.find(function (registration) {
                return registration.formId === formId &&
                    (!instanceId ||
                        !registration.instanceId ||
                        registration.instanceId === instanceId);
            });
            if (!matchingRegistration || matchingRegistration.instanceId) {
                return;
            }
            matchingRegistration.instanceId = instanceId || null;
            log('handleSubmitConversions HubSpot', "Updated HubSpot registration for form ID \"".concat(formId, "\" with instance ID \"").concat(matchingRegistration.instanceId, "\"."));
        });
        hubSpotMessageListenerRegistered = true;
    }
    function registerHubSpotSubmitConversion(element, submitConversionId) {
        log('handleSubmitConversions HubSpot', "Registering HubSpot submit conversion ID \"".concat(submitConversionId, "\"."), element);
        var initialFormId = getHubSpotFormId(element);
        var initialInstanceId = getHubSpotInstanceId(element);
        log('handleSubmitConversions HubSpot', "Initial HubSpot form ID for submit conversion ID \"".concat(submitConversionId, "\": ").concat(initialFormId, ". Initial instance ID: ").concat(initialInstanceId, "."));
        var existingRegistration = hubSpotSubmitRegistrations.find(function (registration) {
            return registration.element === element &&
                registration.submitConversionId === submitConversionId;
        });
        if (existingRegistration) {
            if (existingRegistration.formId === null) {
                existingRegistration.formId = getHubSpotFormId(element);
            }
            if (existingRegistration.instanceId === null) {
                existingRegistration.instanceId = getHubSpotInstanceId(element);
            }
            log('handleSubmitConversions HubSpot', "HubSpot submit conversion ID \"".concat(submitConversionId, "\" already registered with form ID \"").concat(existingRegistration.formId, "\" and instance ID \"").concat(existingRegistration.instanceId, "\"."));
            return;
        }
        ensureHubSpotMessageListener();
        var registration = {
            element: element,
            submitConversionId: submitConversionId,
            formId: initialFormId,
            instanceId: initialInstanceId,
            observer: null,
            hasConverted: false,
        };
        var lookForHubSpotForm = function () {
            var _a;
            var formId = getHubSpotFormId(element);
            var instanceId = getHubSpotInstanceId(element);
            if (!formId) {
                log('handleSubmitConversions HubSpot', "HubSpot form not found yet for submit conversion ID \"".concat(submitConversionId, "\"."));
                return;
            }
            registration.formId = formId;
            registration.instanceId = instanceId;
            log('handleSubmitConversions HubSpot', "Found HubSpot form ID \"".concat(registration.formId, "\" and instance ID \"").concat(registration.instanceId, "\" for submit conversion ID \"").concat(submitConversionId, "\"."), element);
            (_a = registration.observer) === null || _a === void 0 ? void 0 : _a.disconnect();
            registration.observer = null;
        };
        lookForHubSpotForm();
        if (!registration.formId) {
            registration.observer = new MutationObserver(function () {
                lookForHubSpotForm();
            });
            registration.observer.observe(element, {
                childList: true,
                subtree: true,
            });
        }
        hubSpotSubmitRegistrations.push(registration);
    }
    function handlePageViewConversion(pageViewConversions) {
        var _this = this;
        log('handlePageViewConversion', "Handling page view conversions.");
        if (pageViewConversions.length === 0) {
            log('handlePageViewConversion', "No page view conversions found.");
            return;
        }
        log('handlePageViewConversion', "Found page view conversions:", pageViewConversions);
        pageViewConversions.forEach(function (pageViewConversion) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!doesUrlMatchCurrentOrigin(pageViewConversion.url, pageViewConversion.sameOrigin, pageViewConversion.urlMatchType)) return [3 /*break*/, 2];
                        log('handlePageViewConversion', "Sending page view conversion with userFriendlyId: ".concat(pageViewConversion.userFriendlyId, "."));
                        // PAGE_VIEW is not an engagement conversion - it fires automatically
                        return [4 /*yield*/, sendConversionEvent(pageViewConversion.userFriendlyId, false)];
                    case 1:
                        // PAGE_VIEW is not an engagement conversion - it fires automatically
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    }
    function handleProgrammaticConversion(userFriendlyConversionId) {
        return __awaiter(this, void 0, void 0, function () {
            var error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        log('handleProgrammaticConversion', "Handling programmatic conversion with userFriendlyConversionId: ".concat(userFriendlyConversionId, "."));
                        if (!window.optibaseInitialized) {
                            console.error('[Optibase] Did not send conversion event: Optibase did not fully initialize');
                            return [2 /*return*/];
                        }
                        if (window.monthlyTestedUsersLimitReached) {
                            console.error('[Optibase] Did not send conversion event: Monthly Tested Users limit has been reached.');
                            return [2 /*return*/];
                        }
                        if (window.noTestsOrConversionsOnPage) {
                            console.error('[Optibase] Did not send conversion event: No tests or conversions found on the page. The conversion needs to be programmatic.');
                            return [2 /*return*/];
                        }
                        if (window.userNotLoggedIn7Days) {
                            console.error('[Optibase] Did not send conversion event: The user has not logged in in the last 7 days.');
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, sendConversionEvent(userFriendlyConversionId)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        console.error("[Optibase] Error occurred while sending a conversion event. Details:", error_5);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    window.optibaseSendConversionEvent = handleProgrammaticConversion;
    function getScrollDepth() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var documentHeight = document.documentElement.scrollHeight;
        var windowHeight = window.innerHeight;
        var scrollDepth = scrollTop + windowHeight;
        return (scrollDepth / documentHeight) * 100; // returns scroll depth as a percentage of total document height
    }
    function calculateTriggerDepth(conversion) {
        var documentHeight = document.documentElement.scrollHeight;
        if (conversion.scrollDepthUnit === ScrollDepthUnit.PERCENTAGE) {
            return conversion.scrollDepthValue; // Already in percentage
        }
        else if (conversion.scrollDepthUnit === ScrollDepthUnit.PIXELS) {
            return (conversion.scrollDepthValue / documentHeight) * 100; // Convert pixels to percentage
        }
        return Infinity; // Default to a very high value if no valid unit is found, effectively disabling the conversion
    }
    function handleScrollDepthConversions(scrollConversions) {
        log('handleScrollConversions', "Setting up scroll listeners.");
        var eligableScrollConversions = scrollConversions.filter(function (conversion) {
            return doesUrlMatchCurrentOrigin(conversion.url, conversion.sameOrigin, UrlMatchType.EXACT);
        });
        if (eligableScrollConversions.length === 0) {
            log('handleScrollConversions', "No scroll depth conversions found.");
            return;
        }
        log('handleScrollConversions', "Found scroll depth conversions:", eligableScrollConversions);
        // Ensure conversions are only triggered once
        var triggeredConversions = new Set();
        window.addEventListener('scroll', function () {
            var scrollDepth = getScrollDepth();
            eligableScrollConversions.forEach(function (conversion) {
                if (!triggeredConversions.has(conversion.userFriendlyId)) {
                    var triggerDepth = calculateTriggerDepth(conversion);
                    if (scrollDepth >= triggerDepth) {
                        log('Scroll Depth Conversion Triggered', "Conversion ID: ".concat(conversion.userFriendlyId));
                        sendConversionEvent(conversion.userFriendlyId);
                        triggeredConversions.add(conversion.userFriendlyId);
                    }
                }
            });
        }, { passive: true });
    }
    function handleTimeOnPageConversions(timeOnPageConversions) {
        log('handleTimeOnPageConversions', "Setting up time on page listeners.");
        var eligableTimeOnPageConversions = timeOnPageConversions.filter(function (conversion) {
            return doesUrlMatchCurrentOrigin(conversion.url, conversion.sameOrigin, UrlMatchType.EXACT);
        });
        if (eligableTimeOnPageConversions.length === 0) {
            log('handleTimeOnPageConversions', "No time on page conversions found.");
            return;
        }
        log('handleTimeOnPageConversions', "Found time on page conversions:", eligableTimeOnPageConversions);
        var _loop_2 = function (conversion) {
            setTimeout(function () {
                log('Time On Page Conversion Triggered', "Conversion ID: ".concat(conversion.userFriendlyId));
                // TIME_ON_PAGE is not an engagement conversion - already captured by timeOnPage field
                sendConversionEvent(conversion.userFriendlyId, false);
            }, conversion.timeOnPage * 1000);
        };
        for (var _i = 0, eligableTimeOnPageConversions_1 = eligableTimeOnPageConversions; _i < eligableTimeOnPageConversions_1.length; _i++) {
            var conversion = eligableTimeOnPageConversions_1[_i];
            _loop_2(conversion);
        }
    }
    var setTestedUserExternalIdInFlight = new Map();
    function setTestedUserExternalId(externalId) {
        return __awaiter(this, void 0, void 0, function () {
            var inFlightRequest, setTestedUserExternalIdBody, requestPromise;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        log('setTestedUserExternalId', "Setting tested user external ID:", externalId);
                        if (window.monthlyTestedUsersLimitReached) {
                            console.error('[Optibase] Did not set Tested User External ID: Monthly Tested Users limit has been reached.');
                            return [2 /*return*/];
                        }
                        if (window.userNotLoggedIn7Days) {
                            console.error('[Optibase] Did not send conversion event: The user has not logged in in the last 7 days.');
                            return [2 /*return*/];
                        }
                        if (!publicApiKey) {
                            console.error('[Optibase] Did not set Tested User External ID: Public API Key is not set.');
                            return [2 /*return*/];
                        }
                        if (!testedUserId) {
                            console.error("[Optibase] Did not set Tested User External ID: Tested User ID is not set. This user hasn't encountered any tests yet.");
                            return [2 /*return*/];
                        }
                        if (!window.optibaseInitialized) {
                            console.error('[Optibase] Did not set Tested User External ID: Optibase did not fully initialized.');
                            return [2 /*return*/];
                        }
                        if (externalId === testedUserExternalId) {
                            log('setTestedUserExternalId', 'Skipping request because tested user external ID is already set.', externalId);
                            return [2 /*return*/];
                        }
                        inFlightRequest = setTestedUserExternalIdInFlight.get(externalId);
                        if (inFlightRequest) {
                            log('setTestedUserExternalId', 'Reusing in-flight request for tested user external ID.', externalId);
                            return [2 /*return*/, inFlightRequest];
                        }
                        setTestedUserExternalIdBody = {
                            publicApiKey: publicApiKey,
                            testedUserId: testedUserId,
                            testedUserExternalId: externalId,
                        };
                        log('setTestedUserExternalId', "Calling with body:", setTestedUserExternalIdBody);
                        requestPromise = (function () { return __awaiter(_this, void 0, void 0, function () {
                            var response, responseJson_4, responseText, responseJson;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, fetch("".concat(baseApiUrl, "/api/script/setTestedUserExternalId"), {
                                            method: 'POST',
                                            headers: {
                                                'Content-Type': 'application/json',
                                            },
                                            body: JSON.stringify(setTestedUserExternalIdBody),
                                        })];
                                    case 1:
                                        response = _a.sent();
                                        if (!response) {
                                            throw new Error('[Optibase] Response not ok when calling setTestedUserExternalId: No response.');
                                        }
                                        if (!!response.ok) return [3 /*break*/, 4];
                                        return [4 /*yield*/, response.json().catch(function () { })];
                                    case 2:
                                        responseJson_4 = _a.sent();
                                        return [4 /*yield*/, response.text().catch(function () { })];
                                    case 3:
                                        responseText = _a.sent();
                                        if (response.status === 400 && !responseJson_4.clientError) {
                                            // This means it was a user error, like running on
                                            // a non valid domain
                                            throw new OptibaseUserError('[Optibase] Response not ok when calling setTestedUserExternalId: ' +
                                                (responseJson_4 === null || responseJson_4 === void 0 ? void 0 : responseJson_4.message) ||
                                                responseText ||
                                                'Unknown error');
                                        }
                                        else if (response.status === 500) {
                                            // This means it was an error on the server, don't surface to Sentry
                                            throw new OptibaseUserError('[Optibase] Response not ok when calling setTestedUserExternalId: ' +
                                                (responseJson_4 === null || responseJson_4 === void 0 ? void 0 : responseJson_4.message) ||
                                                responseText ||
                                                'Internal Server Error');
                                        }
                                        else {
                                            throw new Error('[Optibase] Response not ok when calling setTestedUserExternalId: ' +
                                                (responseJson_4 === null || responseJson_4 === void 0 ? void 0 : responseJson_4.message) ||
                                                responseText ||
                                                'Unknown error');
                                        }
                                        _a.label = 4;
                                    case 4: return [4 /*yield*/, response.json()];
                                    case 5:
                                        responseJson = _a.sent();
                                        if (responseJson === null || responseJson === void 0 ? void 0 : responseJson.bot) {
                                            return [2 /*return*/];
                                        }
                                        testedUserExternalId = externalId;
                                        window.optibaseTestedUserExternalId = externalId;
                                        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem('optibaseTestedUserExternalId', externalId);
                                        if (amplitudeEnabled && isAmplitudeInstalled()) {
                                            // @ts-ignore
                                            window.amplitude.setUserId(externalId);
                                        }
                                        log('setTestedUserExternalId', "Response:", responseJson);
                                        return [2 /*return*/];
                                }
                            });
                        }); })();
                        setTestedUserExternalIdInFlight.set(externalId, requestPromise);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, requestPromise];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        if (setTestedUserExternalIdInFlight.get(externalId) === requestPromise) {
                            setTestedUserExternalIdInFlight.delete(externalId);
                        }
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    window.optibaseSetTestedUserExternalId = setTestedUserExternalId;
    // Customer callbacks and analytics SDKs must not interrupt core tracking.
    function runExternalCallback(scope, callback) {
        var reportError = function (error) {
            console.error("[Optibase] Error in ".concat(scope, ":"), error);
        };
        try {
            var result = callback();
            // Preserve synchronous completion while observing returned promises/thenables.
            if (result && typeof result.then === 'function') {
                return Promise.resolve(result).catch(reportError);
            }
        }
        catch (error) {
            reportError(error);
        }
    }
    var optibaseActiveVariantsListeners = [];
    var executingActiveVariantsListeners = new Set();
    function invokeActiveVariantsListener(callback, variants) {
        // Block re-entry until completion, including cycles through other listeners.
        if (executingActiveVariantsListeners.has(callback)) {
            console.warn('[Optibase] Active variants listener is already executing; skipping recursive invocation.');
            return;
        }
        executingActiveVariantsListeners.add(callback);
        var pending;
        var clearExecuting = function () {
            executingActiveVariantsListeners.delete(callback);
        };
        try {
            pending = runExternalCallback('active variants listener', function () {
                return callback(variants);
            });
            if (pending) {
                void pending.then(clearExecuting, clearExecuting);
            }
        }
        finally {
            if (!pending) {
                clearExecuting();
            }
        }
    }
    function optibaseAddActiveVariantsListener(callback) {
        // Store each listener once, but preserve immediate notification on later calls.
        if (!optibaseActiveVariantsListeners.includes(callback)) {
            optibaseActiveVariantsListeners.push(callback);
        }
        if (window.optibaseActiveVariants) {
            invokeActiveVariantsListener(callback, window.optibaseActiveVariants);
        }
    }
    window.optibaseAddActiveVariantsListener = optibaseAddActiveVariantsListener;
    /* ---------- Execution Starts Here --------- */
    var debugMode = false;
    var localStorage = null;
    var _a = validateExecution(), publicApiKey = _a.publicApiKey, baseApiUrl = _a.baseApiUrl, canHideBody = _a.canHideBody;
    if (isBotUserAgent(navigator.userAgent)) {
        window.optibaseScriptLoaded = true;
        window.optibaseInitialized = true;
        console.debug('[Optibase] Bot traffic detected; skipping Optibase setup.');
        return;
    }
    // Local storage can sometimes be blocked and throw an error:
    // Failed to read the 'localStorage' property from 'Window': Access is denied for this document.
    try {
        localStorage = window.localStorage;
        localStorage.getItem('optibase');
    }
    catch (_b) {
        localStorage = null;
    }
    // Used to detect if script has already been loaded before.
    window.optibaseScriptLoaded = true;
    var startDate = null;
    var _c = getConfig(), scriptDisabled = _c.scriptDisabled, previewVariant = _c.previewVariant, forcedVariants = _c.forcedVariants;
    // Metadata Variables - Are final and will not be modified by the script.
    var currentBrowser = getCurrentBrowser();
    var currentOS = getCurrentOS();
    var currentScreenSize = getCurrentScreenSize();
    window.optibaseScreenSize = currentScreenSize;
    var currentTopReferrer = getCurrentTopReferrer();
    Sentry.setTag('browser', currentBrowser);
    Sentry.setTag('os', currentOS);
    var currentOriginUrl = getCurrentOriginUrl();
    var cleanCurrentOriginUrl = validateAndCleanUrl(currentOriginUrl);
    var cleanCurrentOriginPath = validateAndExtractPathFromUrl(currentOriginUrl);
    // Dynamic Variables - Are not final and might be modified by the script.
    // Check URL parameter first for cross-domain tracking, then fall back to localStorage
    var urlParams = new URLSearchParams(window.location.search);
    var testedUserId = urlParams.get('optibase_uid') ||
        (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('optibaseTestedUserId'));
    window.optibaseTestedUserId = testedUserId;
    var testedUserExternalId = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('optibaseTestedUserExternalId');
    window.optibaseTestedUserExternalId = testedUserExternalId;
    var shownVariants = [];
    // Bounce tracking variables
    var currentViewId = null;
    var pageLoadTime = Date.now();
    var hadConversion = false;
    var hadEngagementConversion = false;
    var bounceSent = false;
    var maxScrollDepth = 0;
    // Consent mode variables
    var consentMode = 'default';
    var consentBannerConfig = null;
    var trackingEnabled = false;
    var userDeclinedConsent = false;
    var pendingViewVariants = [];
    var cachedConversions = [];
    var amplitudeEnabled = false;
    var shouldLoadHeatmapScriptOnConsent = false;
    var shouldLoadRecordingScriptOnConsent = false;
    var calendlySubmitRegistrations = [];
    var calendlyMessageListenerRegistered = false;
    var hubSpotSubmitRegistrations = [];
    var hubSpotMessageListenerRegistered = false;
    // Consent storage functions
    function getStoredConsent() {
        var stored = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("optibaseConsent:".concat(publicApiKey));
        if (stored === 'true')
            return true;
        if (stored === 'false')
            return false;
        return null;
    }
    function setStoredConsent(consent) {
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("optibaseConsent:".concat(publicApiKey), String(consent));
    }
    // Consent banner UI
    function showConsentBanner() {
        var _this = this;
        log('showConsentBanner', 'Displaying consent banner');
        var config = consentBannerConfig || {
            title: 'Cookie Consent',
            description: "This website collects interaction data to run experiments and improve your experience using Optibase. Your activity may be tracked and analyzed while you're on this page. No personal information is sold or shared with third parties.",
            acceptText: 'Accept',
            declineText: 'Deny',
        };
        var banner = document.createElement('div');
        banner.id = 'optibase-consent-banner';
        banner.innerHTML = "\n      <div style=\"position:fixed;bottom:1rem;left:1rem;width:20rem;background:#fff;\n        border:1px solid #e5e7eb;border-radius:0.5rem;padding:1.5rem;\n        z-index:999999;font-family:system-ui,-apple-system,sans-serif;\n        box-shadow:0 10px 15px -3px rgba(0,0,0,0.1),0 4px 6px -2px rgba(0,0,0,0.05)\">\n        <h3 style=\"margin:0;font-size:1.125rem;font-weight:600;color:#111827;line-height:1.75rem\">".concat(config.title, "</h3>\n        <p style=\"margin:0.5rem 0 0 0;font-size:0.875rem;color:#4b5563;line-height:1.25rem\">").concat(config.description).concat(config.linkText && config.linkUrl ? " <a href=\"".concat(config.linkUrl, "\" target=\"_blank\" rel=\"noopener noreferrer\" style=\"color:inherit;text-decoration:underline\">").concat(config.linkText, "</a>") : '', "</p>\n        <div style=\"margin-top:1rem;display:flex;gap:0.75rem\">\n          <button id=\"optibase-decline\" style=\"border-radius:0.375rem;border:1px solid #d1d5db;\n            background:#fff;padding:0.5rem 1rem;font-size:0.875rem;font-weight:500;\n            color:#374151;cursor:pointer\">").concat(config.declineText, "</button>\n          <button id=\"optibase-accept\" style=\"border-radius:0.375rem;border:none;\n            background:#111827;padding:0.5rem 1rem;font-size:0.875rem;font-weight:500;\n            color:#fff;cursor:pointer\">").concat(config.acceptText, "</button>\n        </div>\n      </div>");
        document.body.appendChild(banner);
        // Add hover effects
        var declineBtn = document.getElementById('optibase-decline');
        var acceptBtn = document.getElementById('optibase-accept');
        declineBtn === null || declineBtn === void 0 ? void 0 : declineBtn.addEventListener('mouseenter', function () {
            declineBtn.style.background = '#f9fafb';
        });
        declineBtn === null || declineBtn === void 0 ? void 0 : declineBtn.addEventListener('mouseleave', function () {
            declineBtn.style.background = '#fff';
        });
        acceptBtn === null || acceptBtn === void 0 ? void 0 : acceptBtn.addEventListener('mouseenter', function () {
            acceptBtn.style.background = '#1f2937';
        });
        acceptBtn === null || acceptBtn === void 0 ? void 0 : acceptBtn.addEventListener('mouseleave', function () {
            acceptBtn.style.background = '#111827';
        });
        acceptBtn === null || acceptBtn === void 0 ? void 0 : acceptBtn.addEventListener('click', function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        banner.remove();
                        setStoredConsent(true);
                        return [4 /*yield*/, enableTracking()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        declineBtn === null || declineBtn === void 0 ? void 0 : declineBtn.addEventListener('click', function () {
            banner.remove();
            setStoredConsent(false);
            log('showConsentBanner', 'User declined consent');
        });
    }
    // Enable tracking function - called when user gives consent
    function enableTracking() {
        return __awaiter(this, void 0, void 0, function () {
            var enableTrackingBody, response, responseJson, enableTrackingResponse, newId, viewId, error_6;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (trackingEnabled) {
                            log('enableTracking', 'Tracking already enabled, skipping');
                            return [2 /*return*/];
                        }
                        log('enableTracking', 'Enabling tracking');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, , 7]);
                        enableTrackingBody = {
                            publicApiKey: publicApiKey,
                            screenSize: currentScreenSize,
                            entryUrl: currentOriginUrl,
                            topReferrer: currentTopReferrer,
                            OS: currentOS,
                            browser: currentBrowser,
                            variants: pendingViewVariants,
                        };
                        log('enableTracking', 'Calling with body:', enableTrackingBody);
                        return [4 /*yield*/, fetch("".concat(baseApiUrl, "/api/script/enableTracking"), {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                credentials: 'include',
                                body: JSON.stringify(enableTrackingBody),
                            })];
                    case 2:
                        response = _b.sent();
                        if (!!response.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.json().catch(function () { })];
                    case 3:
                        responseJson = _b.sent();
                        console.error('[Optibase] Error enabling tracking:', (responseJson === null || responseJson === void 0 ? void 0 : responseJson.message) || 'Unknown error');
                        return [2 /*return*/];
                    case 4: return [4 /*yield*/, response.json()];
                    case 5:
                        enableTrackingResponse = _b.sent();
                        if ((enableTrackingResponse === null || enableTrackingResponse === void 0 ? void 0 : enableTrackingResponse.bot) ||
                            !(enableTrackingResponse === null || enableTrackingResponse === void 0 ? void 0 : enableTrackingResponse.testedUserId)) {
                            log('enableTracking', 'Bot sentinel received; skipping tracking enable');
                            return [2 /*return*/];
                        }
                        newId = enableTrackingResponse.testedUserId, viewId = enableTrackingResponse.viewId;
                        testedUserId = newId;
                        window.optibaseTestedUserId = newId;
                        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem('optibaseTestedUserId', newId);
                        trackingEnabled = true;
                        // Set active variants for heatmap/recording scripts
                        if (pendingViewVariants.length > 0) {
                            window.optibaseActiveVariants = pendingViewVariants;
                            optibaseActiveVariantsListeners.forEach(function (listener) {
                                return invokeActiveVariantsListener(listener, pendingViewVariants);
                            });
                        }
                        log('enableTracking', "Tracking enabled. TestedUserId: ".concat(newId, ", ViewId: ").concat(viewId));
                        if (viewId) {
                            currentViewId = viewId;
                            // Use actual page load time (startDate) for accurate bounce tracking
                            pageLoadTime = (_a = startDate === null || startDate === void 0 ? void 0 : startDate.getTime()) !== null && _a !== void 0 ? _a : Date.now();
                            hadConversion = false;
                            bounceSent = false;
                            maxScrollDepth = 0;
                            setupBounceTracking();
                        }
                        // Attach conversion listeners now that tracking is enabled
                        if (cachedConversions.length > 0) {
                            handleClickConversions(cachedConversions.filter(function (conversion) {
                                return conversion.type === ConversionType.CLICK ||
                                    conversion.type === ConversionType.LEGACY_CLICK_SUBMIT;
                            }));
                            handleSubmitConversions(cachedConversions.filter(function (conversion) {
                                return conversion.type === ConversionType.SUBMIT ||
                                    conversion.type === ConversionType.LEGACY_CLICK_SUBMIT;
                            }));
                            handleScrollDepthConversions(cachedConversions.filter(function (conversion) { return conversion.type === ConversionType.SCROLL_DEPTH; }));
                            handleTimeOnPageConversions(cachedConversions.filter(function (conversion) { return conversion.type === ConversionType.TIME_ON_PAGE; }));
                            handlePageViewConversion(cachedConversions.filter(function (conversion) { return conversion.type === ConversionType.PAGE_VIEW; }));
                        }
                        // Load heatmap and recording scripts now that tracking is enabled
                        if (shouldLoadHeatmapScriptOnConsent &&
                            !window.monthlyTestedUsersLimitReached) {
                            loadHeatmapScript(baseApiUrl, publicApiKey);
                        }
                        if (shouldLoadRecordingScriptOnConsent &&
                            !window.monthlyTestedUsersLimitReached) {
                            loadRecordingScript(baseApiUrl, publicApiKey);
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        error_6 = _b.sent();
                        console.error('[Optibase] Error enabling tracking:', error_6);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    // Expose for external consent mode
    window.optibaseEnableTracking = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    log('optibaseEnableTracking', 'Called externally');
                    setStoredConsent(true);
                    return [4 /*yield*/, enableTracking()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    if (canHideBody) {
        hideBody();
        // Show body no matter what after 5 seconds
        setTimeout(function () {
            showBody();
        }, 5000);
    }
    // Initializes the testing framework once the DOM content is fully loaded.
    // This function fetches test configurations from the server, processes split and A/B tests,
    // and sets up event listeners for conversion tracking. It also handles visibility of the body
    // element to prevent flickering during test variant application.
    function onDOMContentLoaded() {
        return __awaiter(this, void 0, void 0, function () {
            var variantsOnPage, clickConversionsOnPage, submitConversionsOnPage, testsOnPage, conversionsOnPage, initializeResponse, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        log('onDOMContentLoaded', 'DOM Content Loaded');
                        startDate = new Date();
                        variantsOnPage = document.querySelectorAll('[data-optibase-variant-id]');
                        clickConversionsOnPage = document.querySelectorAll('[data-optibase-click-conversion-id]');
                        submitConversionsOnPage = document.querySelectorAll('[data-optibase-submit-conversion-id]');
                        testsOnPage = Boolean(variantsOnPage.length);
                        conversionsOnPage = Boolean(clickConversionsOnPage.length) ||
                            Boolean(submitConversionsOnPage.length);
                        handleCachedInitializeResponse(testsOnPage, conversionsOnPage);
                        if (!Boolean(variantsOnPage.length)) {
                            log('onDOMContentLoaded', "No variants found on the page.");
                        }
                        if (!Boolean(clickConversionsOnPage.length)) {
                            log('onDOMContentLoaded', "No click conversions found on the page.");
                        }
                        if (!Boolean(submitConversionsOnPage.length)) {
                            log('onDOMContentLoaded', "No submit conversions found on the page.");
                        }
                        return [4 /*yield*/, getInitialize(testsOnPage, conversionsOnPage)];
                    case 1:
                        initializeResponse = _a.sent();
                        log('getInitialize', "Received response");
                        return [4 /*yield*/, handleInitializeResponse(initializeResponse, testsOnPage, conversionsOnPage)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_7 = _a.sent();
                        if (!(error_7 instanceof OptibaseUserError)) {
                            optibaseSentryClient === null || optibaseSentryClient === void 0 ? void 0 : optibaseSentryClient.captureException(error_7);
                        }
                        console.error('[Optibase] Encountered an error:', error_7);
                        // Make sure, even if something goes wrong, to show the page at the end.
                        window.optibaseInitialized = true;
                        showBody();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    if (document.readyState !== 'loading') {
        // DOM content already loaded
        onDOMContentLoaded();
    }
    else {
        document.addEventListener('DOMContentLoaded', onDOMContentLoaded);
    }
}
try {
    Optibase();
}
catch (error) {
    if (!(error instanceof OptibaseUserError)) {
        optibaseSentryClient === null || optibaseSentryClient === void 0 ? void 0 : optibaseSentryClient.captureException(error);
    }
    throw error;
}
